import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { useRpiGraphqlRequest } from "../../client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** JsonNode scalar. */
  JSON: any;
};

export type AddressResponse = {
  __typename?: "AddressResponse";
  address1?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  address3?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  company?: Maybe<Scalars["String"]>;
  countryIso?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  postalCode?: Maybe<Scalars["String"]>;
  regionIso?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["String"]>;
};

export type AdminCancelOrderInputV2 = {
  orderIdentifier: OrderIdentifierInput;
  reason: Scalars["String"];
};

export type AdminConfigResponse = {
  __typename?: "AdminConfigResponse";
  avalaraTaxConfiguration?: Maybe<Scalars["JSON"]>;
  dataSourceUrl?: Maybe<Scalars["String"]>;
  dynamoDbConfiguration?: Maybe<Scalars["JSON"]>;
  git?: Maybe<Scalars["JSON"]>;
  holdingBinReleaseInHours?: Maybe<Scalars["Int"]>;
  nextChargeTime?: Maybe<Scalars["String"]>;
  pdfProcessingConfiguration?: Maybe<Scalars["JSON"]>;
  shippingConfiguration?: Maybe<Scalars["JSON"]>;
  tasksConfiguration?: Maybe<Scalars["JSON"]>;
  uosClientConfiguration?: Maybe<Scalars["JSON"]>;
};

export type AdminOverridePaymentStatusInput = {
  newPaymentStatus: PaymentStatus;
  orderIdentifier: OrderIdentifierInput;
  reason: Scalars["String"];
};

export type ApiCredentialSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<ApiCredentialSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/** ##### Api credential  search */
export enum ApiCredentialSearchFields {
  ApiKey = "apiKey",
  CustomerPublicId = "customerPublicId",
  Description = "description",
  IsSandbox = "isSandbox",
  SharedSecret = "sharedSecret",
  WebhookSecret = "webhookSecret",
}

export type ApiCredentialSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: ApiCredentialSearchFields;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type ApiCredentialsInput = {
  description?: InputMaybe<Scalars["String"]>;
  isSandbox?: InputMaybe<Scalars["Boolean"]>;
};

export type ApiCredentialsResponse = {
  __typename?: "ApiCredentialsResponse";
  apiKey: Scalars["String"];
  customerPublicId: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  isSandbox: Scalars["Boolean"];
  settings: Scalars["JSON"];
  sharedSecret: Scalars["String"];
  webhookSecret: Scalars["String"];
};

export type BraintreeCheckoutInput = {
  customerOrderIds: Array<Scalars["String"]>;
  deviceDataFromClient?: InputMaybe<Scalars["String"]>;
  token: Scalars["String"];
};

export type BraintreeCheckoutResponse = {
  __typename?: "BraintreeCheckoutResponse";
  braintreeTransactionId?: Maybe<Scalars["String"]>;
  message?: Maybe<Scalars["String"]>;
};

export type BraintreePaymentMethodEditInput = {
  cardholderName?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  deviceDataFromClient?: InputMaybe<Scalars["String"]>;
  makeDefault?: InputMaybe<Scalars["Boolean"]>;
  state?: InputMaybe<Scalars["String"]>;
  streetAddress: Scalars["String"];
  token: Scalars["String"];
};

export type BraintreePaymentMethodInput = {
  cardholderName?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  deviceDataFromClient?: InputMaybe<Scalars["String"]>;
  makeDefault?: InputMaybe<Scalars["Boolean"]>;
  paymentMethodNonce: Scalars["String"];
  state?: InputMaybe<Scalars["String"]>;
  streetAddress: Scalars["String"];
};

export type BraintreePaymentMethodRejection = {
  __typename?: "BraintreePaymentMethodRejection";
  message: Scalars["String"];
  validationErrors: Array<BraintreeValidationError>;
  verification?: Maybe<BraintreeVerification>;
};

export type BraintreePaymentMethodResponse = {
  __typename?: "BraintreePaymentMethodResponse";
  address?: Maybe<Scalars["String"]>;
  cardholderName?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  countryIso2?: Maybe<Scalars["String"]>;
  countryName?: Maybe<Scalars["String"]>;
  customerId?: Maybe<Scalars["String"]>;
  expiryDate?: Maybe<Scalars["String"]>;
  imageUrl?: Maybe<Scalars["String"]>;
  isDefault?: Maybe<Scalars["Boolean"]>;
  last4Digits?: Maybe<Scalars["String"]>;
  maskedCCNumber?: Maybe<Scalars["String"]>;
  message?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  postalCode?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  token?: Maybe<Scalars["String"]>;
};

export type BraintreePaymentMethodResult = BraintreePaymentMethodRejection | BraintreePaymentMethodResponse;

export type BraintreeRefundByAmountInput = {
  amountItems: Array<RefundItemAmount>;
  customerOrderId: Scalars["String"];
  reason: RefundReason;
  reasonNote?: InputMaybe<Scalars["String"]>;
};

export type BraintreeRefundByPercentageInput = {
  customerOrderId: Scalars["String"];
  percentageItems: Array<RefundItemPercentage>;
  reason: RefundReason;
  reasonNote?: InputMaybe<Scalars["String"]>;
};

export type BraintreeRefundByQuantityInput = {
  customerOrderId: Scalars["String"];
  quantityItems: Array<RefundItemQuantity>;
  reason: RefundReason;
  reasonNote?: InputMaybe<Scalars["String"]>;
};

export type BraintreeRefundInput = {
  customerOrderId?: InputMaybe<Scalars["String"]>;
  items?: InputMaybe<Array<RefundItem>>;
  reason?: InputMaybe<RefundReason>;
  reasonNote?: InputMaybe<Scalars["String"]>;
  refundStrategy?: InputMaybe<BraintreeRefundStrategy>;
  refundStrategyValue?: InputMaybe<Scalars["Float"]>;
};

export type BraintreeRefundResponse = {
  __typename?: "BraintreeRefundResponse";
  message?: Maybe<Scalars["String"]>;
};

export enum BraintreeRefundStrategy {
  OrderFullValue = "ORDER_FULL_VALUE",
  OrderPartialQty = "ORDER_PARTIAL_QTY",
  OrderPartialValue = "ORDER_PARTIAL_VALUE",
  OrderPercentageZeroToOne = "ORDER_PERCENTAGE_ZERO_TO_ONE",
  ShippingOnly = "SHIPPING_ONLY",
}

export type BraintreeResponse = {
  __typename?: "BraintreeResponse";
  message?: Maybe<Scalars["String"]>;
};

export enum BraintreeTransactionStatus {
  AuthorizationExpired = "AUTHORIZATION_EXPIRED",
  Authorized = "AUTHORIZED",
  Authorizing = "AUTHORIZING",
  Failed = "FAILED",
  GatewayRejected = "GATEWAY_REJECTED",
  ProcessorDeclined = "PROCESSOR_DECLINED",
  Settled = "SETTLED",
  SettlementConfirmed = "SETTLEMENT_CONFIRMED",
  SettlementDeclined = "SETTLEMENT_DECLINED",
  SettlementPending = "SETTLEMENT_PENDING",
  Settling = "SETTLING",
  SubmittedForSettlement = "SUBMITTED_FOR_SETTLEMENT",
  Unrecognized = "UNRECOGNIZED",
  Voided = "VOIDED",
}

export type BraintreeValidationError = {
  __typename?: "BraintreeValidationError";
  attribute: Scalars["String"];
  code: Scalars["String"];
  message: Scalars["String"];
};

export type BraintreeVerification = {
  __typename?: "BraintreeVerification";
  avsErrorResponseCode?: Maybe<Scalars["String"]>;
  avsPostalCodeResponseCode?: Maybe<Scalars["String"]>;
  avsStreetAddressResponseCode?: Maybe<Scalars["String"]>;
  cvvResponseCode?: Maybe<Scalars["String"]>;
  gatewayRejectionReason?: Maybe<Scalars["String"]>;
  networkResponseCode?: Maybe<Scalars["String"]>;
  networkResponseText?: Maybe<Scalars["String"]>;
  processorResponseCode?: Maybe<Scalars["String"]>;
  processorResponseText?: Maybe<Scalars["String"]>;
  processorResponseType?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export type BulletinResponse = {
  __typename?: "BulletinResponse";
  ordersLimit?: Maybe<OrderLimitBulletinResponse>;
  paymentMethodMissing?: Maybe<Scalars["Boolean"]>;
  paymentsAreFailing?: Maybe<Scalars["Boolean"]>;
  taxDocumentNotUploaded?: Maybe<Scalars["Boolean"]>;
};

export type CallbackResponse = {
  __typename?: "CallbackResponse";
  attemptCount?: Maybe<Scalars["Int"]>;
  body?: Maybe<Scalars["JSON"]>;
  timeline?: Maybe<Scalars["JSON"]>;
  urlEndpoint?: Maybe<Scalars["String"]>;
  webhookId?: Maybe<Scalars["String"]>;
  webhookStatus?: Maybe<Scalars["String"]>;
};

export type ChangePasswordDashboardUserInput = {
  newPassword: Scalars["String"];
  requireReset?: InputMaybe<Scalars["Boolean"]>;
  username: Scalars["String"];
};

export type CreateCustomerProductInput = {
  customerPublicId?: InputMaybe<Scalars["String"]>;
  customerSku: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  openapiProductId: Scalars["Int"];
};

export type CreateOrderResponse = {
  __typename?: "CreateOrderResponse";
  customerOrderId: Scalars["String"];
  orderPublicId?: Maybe<Scalars["String"]>;
  validations?: Maybe<Scalars["JSON"]>;
};

export type CreateReprintInputByIdentifier = {
  isFreeOfCharge?: InputMaybe<Scalars["Boolean"]>;
  newShippingClassification?: InputMaybe<OpenapiProvidedShippingClassification>;
  orderIdentifier: OrderIdentifierInput;
  reason?: InputMaybe<Scalars["String"]>;
  replacedPrintAssetsForOrderItems?: InputMaybe<Array<InputMaybe<ReprintReplacedAssets>>>;
};

export type CreateReprintInputV2ByIdentifier = {
  isFreeOfCharge: Scalars["Boolean"];
  orderIdentifier: OrderIdentifierInput;
  reason: Scalars["String"];
  reprintedItems: Array<CreateReprintOrderItem>;
  shippingClassification: OpenapiProvidedShippingClassification;
};

export type CreateReprintOrderItem = {
  orderItemId: Scalars["Int"];
  quantity?: InputMaybe<Scalars["Int"]>;
};

export type CreateUploadInput = {
  customerPublicId: Scalars["String"];
  files: Array<UploadingFilesInput>;
};

export type CustomerCommunicationResponse = {
  __typename?: "CustomerCommunicationResponse";
  contents?: Maybe<Scalars["JSON"]>;
  createdAt: Scalars["String"];
  customer?: Maybe<CustomerResponse>;
  email?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  type: CustomerCommunicationType;
};

export type CustomerCommunicationSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<CustomerCommunicationSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/** ##### Customer communication  search */
export enum CustomerCommunicationSearchFields {
  CreatedAt = "createdAt",
  CustomerPublicId = "customerPublicId",
  Email = "email",
  Id = "id",
  Type = "type",
}

export type CustomerCommunicationSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: CustomerCommunicationSearchFields;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export enum CustomerCommunicationType {
  SharedIdea = "SHARED_IDEA",
  SignupSurvey = "SIGNUP_SURVEY",
}

export type CustomerInput = {
  email?: InputMaybe<Scalars["String"]>;
  emailUpdates: Scalars["Boolean"];
  publicId: Scalars["String"];
};

export type CustomerProductResponse = {
  __typename?: "CustomerProductResponse";
  createdAt: Scalars["String"];
  customer?: Maybe<CustomerResponse>;
  customerPublicId: Scalars["String"];
  customerSku: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  name?: Maybe<Scalars["String"]>;
  openapiProduct?: Maybe<OpenapiProductResponse>;
  openapiProductId: Scalars["Int"];
};

export type CustomerProductSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<CustomerProductSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/**
 * ##
 * ## Customer product search
 */
export enum CustomerProductSearchField {
  CustomerPublicId = "customerPublicId",
  CustomerSku = "customerSku",
  Description = "description",
  Id = "id",
  Name = "name",
  OpenapiProductId = "openapiProductId",
}

export type CustomerProductSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: CustomerProductSearchField;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type CustomerResponse = {
  __typename?: "CustomerResponse";
  chargeTax: Scalars["Boolean"];
  createdAt: Scalars["String"];
  dashboardUsers?: Maybe<Array<Maybe<DashboardUserResponse>>>;
  email?: Maybe<Scalars["String"]>;
  emailUpdates: Scalars["Boolean"];
  id: Scalars["Int"];
  isOnboardingComplete?: Maybe<Scalars["Boolean"]>;
  organization: OrganizationInformation;
  organizationName?: Maybe<Scalars["String"]>;
  pdfProcessingApiaccount?: Maybe<Scalars["String"]>;
  publicId: Scalars["String"];
  secretKey?: Maybe<Scalars["String"]>;
  settings?: Maybe<CustomerSettings>;
  taxDocuments?: Maybe<Array<UploadedFileResponse>>;
  updatedAt: Scalars["String"];
};

export type CustomerSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<CustomerSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/** ##### Customer search */
export enum CustomerSearchFields {
  CreatedAt = "createdAt",
  Email = "email",
  Id = "id",
  PublicId = "publicId",
}

export type CustomerSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: CustomerSearchFields;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type CustomerSettings = {
  __typename?: "CustomerSettings";
  allowCreateOrderFromPrintAsset: Scalars["Boolean"];
  allowInstantPayment: Scalars["Boolean"];
  allowMultipleCurrencies: Scalars["Boolean"];
  allowPrintAssetCreation: Scalars["Boolean"];
  ordersLimit?: Maybe<CustomerSettingsOrdersLimitResponse>;
  payments?: Maybe<CustomerSettingsPayments>;
  pricing?: Maybe<CustomerSettingsPricing>;
  shipping?: Maybe<CustomerSettingsShipping>;
  timeZone?: Maybe<Scalars["String"]>;
  vaultCustomerId?: Maybe<Scalars["String"]>;
};

export type CustomerSettingsOrdersLimit = {
  limitQueueSize: Scalars["Int"];
  maxOrders: Scalars["Int"];
};

export type CustomerSettingsOrdersLimitResponse = {
  __typename?: "CustomerSettingsOrdersLimitResponse";
  limitQueueSize: Scalars["Int"];
  maxOrders: Scalars["Int"];
};

export enum CustomerSettingsPayments {
  External = "EXTERNAL",
  Scheduled = "SCHEDULED",
}

export enum CustomerSettingsPricing {
  External = "EXTERNAL",
  Openapi = "OPENAPI",
}

export enum CustomerSettingsShipping {
  Flat = "FLAT",
  ShippingService = "SHIPPING_SERVICE",
}

export enum CustomerType {
  Enterprise = "ENTERPRISE",
  Generic = "GENERIC",
}

export type DailyOrdersMetricsResponse = {
  __typename?: "DailyOrdersMetricsResponse";
  customerPublicId: Scalars["String"];
  days: Array<SingleDayMetricsResponse>;
  numberOfDays: Scalars["Int"];
};

export type DashboardUserInput = {
  customerPublicId?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  role: DashboardUserRole;
  username: Scalars["String"];
};

export type DashboardUserResponse = {
  __typename?: "DashboardUserResponse";
  createdAt: Scalars["String"];
  customer?: Maybe<CustomerResponse>;
  customerPublicId?: Maybe<Scalars["String"]>;
  disabled?: Maybe<Scalars["Boolean"]>;
  email?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  lastName?: Maybe<Scalars["String"]>;
  role?: Maybe<DashboardUserRole>;
  settings?: Maybe<Scalars["JSON"]>;
  sub?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["String"];
  username?: Maybe<Scalars["String"]>;
};

export enum DashboardUserRole {
  CustomerAdmin = "CUSTOMER_ADMIN",
  SuperAdmin = "SUPER_ADMIN",
  User = "USER",
}

export type DashboardUserSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<DashboardUserSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/** ##### Dashboard user search */
export enum DashboardUserSearchFields {
  CreatedAt = "createdAt",
  CustomerPublicId = "customerPublicId",
  Disabled = "disabled",
  Email = "email",
  Id = "id",
  Role = "role",
  Username = "username",
}

export type DashboardUserSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: DashboardUserSearchFields;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type DateFilterInput = {
  from?: InputMaybe<Scalars["String"]>;
  to?: InputMaybe<Scalars["String"]>;
};

export type DestinationResponse = {
  __typename?: "DestinationResponse";
  address?: Maybe<AddressResponse>;
  facility?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  shippingDetails?: Maybe<Scalars["JSON"]>;
  shippingMethodCode?: Maybe<Scalars["String"]>;
};

export type EditCustomerInput = {
  email: Scalars["String"];
  emailUpdates: Scalars["Boolean"];
  ordersLimit?: InputMaybe<CustomerSettingsOrdersLimit>;
  publicId: Scalars["String"];
  timeZone: Scalars["String"];
};

export type EditCustomerProductInput = {
  description?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  newCustomerSku: Scalars["String"];
};

export type EditDashboardUserInput = {
  customerPublicId?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  role: DashboardUserRole;
  username: Scalars["String"];
};

export type EditOrganizationInformationInput = {
  country?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type MonthlyOrdersByStatusDataPoint = {
  __typename?: "MonthlyOrdersByStatusDataPoint";
  month: Scalars["String"];
  statusCounts: Array<OrderStatusCount>;
};

export type MonthlyPaymentDataPoint = {
  __typename?: "MonthlyPaymentDataPoint";
  currency: SupportedCurrency;
  month: Scalars["String"];
  netPaymentAmount: Scalars["Float"];
};

export type Mutation = {
  __typename?: "Mutation";
  /** @deprecated Use adminCancelOrderByIdentifierV2 to record a cancellation reason */
  adminCancelOrderByIdentifier?: Maybe<OrderResponse>;
  adminCancelOrderByIdentifierV2?: Maybe<OrderResponse>;
  adminCreateCustomer: CustomerResponse;
  adminEditCustomer: CustomerResponse;
  adminEditCustomerLimits: CustomerResponse;
  adminMarkOrderAsStaffOrderByIdentifier?: Maybe<OrderResponse>;
  adminOverridePaymentStatus?: Maybe<OrderResponse>;
  adminRedriveOrderByIdentifier?: Maybe<OrderResponse>;
  adminRefundOrder: BraintreeRefundResponse;
  adminRefundOrderByAmount: BraintreeRefundResponse;
  adminRefundOrderByPercentage: BraintreeRefundResponse;
  adminRefundOrderByQuantity: BraintreeRefundResponse;
  adminReleaseOrderFromHoldingBinByIdentifier?: Maybe<OrderResponse>;
  adminTaxReview?: Maybe<TaxReviewResponse>;
  adminUpdateCustomerSecretAndSettings: CustomerResponse;
  adminUpdateOrderStatusByIdentifier?: Maybe<OrderResponse>;
  apiCredentialsCreate: ApiCredentialsResponse;
  braintreePaymentCreate: BraintreeCheckoutResponse;
  customerProductCreate: CustomerProductResponse;
  customerProductEdit: CustomerProductResponse;
  dashboardUserChangePassword: DashboardUserResponse;
  dashboardUserCreate: DashboardUserResponse;
  dashboardUserDelete: Scalars["String"];
  dashboardUserEdit: DashboardUserResponse;
  dashboardUserUpdateSettings: DashboardUserResponse;
  editOrganizationInformation: CustomerResponse;
  onboardCustomer?: Maybe<CustomerResponse>;
  orderReprintCreateByIdentifier: CreateOrderResponse;
  orderReprintCreateV2ByIdentifier: CreateOrderResponse;
  paymentMethodCreate: BraintreePaymentMethodResponse;
  paymentMethodCreateV2: BraintreePaymentMethodResult;
  paymentMethodDelete?: Maybe<BraintreeResponse>;
  paymentMethodEdit: BraintreePaymentMethodResponse;
  paymentMethodEditV2: BraintreePaymentMethodResult;
  sandboxPaymentNotification: SandboxPaymentNotificationResponse;
  uploadCreate?: Maybe<UploadServiceV2CollectionsStatusResponse>;
  uploadedFileDelete?: Maybe<UploadedFileDeleteResponse>;
};

export type MutationAdminCancelOrderByIdentifierArgs = {
  orderIdentifier: OrderIdentifierInput;
};

export type MutationAdminCancelOrderByIdentifierV2Args = {
  input: AdminCancelOrderInputV2;
};

export type MutationAdminCreateCustomerArgs = {
  createCustomerInput?: InputMaybe<CustomerInput>;
};

export type MutationAdminEditCustomerArgs = {
  editCustomerInput?: InputMaybe<EditCustomerInput>;
};

export type MutationAdminEditCustomerLimitsArgs = {
  customerPublicId: Scalars["String"];
  customerSettingsOrdersLimit?: InputMaybe<CustomerSettingsOrdersLimit>;
};

export type MutationAdminMarkOrderAsStaffOrderByIdentifierArgs = {
  orderIdentifier: OrderIdentifierInput;
};

export type MutationAdminOverridePaymentStatusArgs = {
  input: AdminOverridePaymentStatusInput;
};

export type MutationAdminRedriveOrderByIdentifierArgs = {
  orderIdentifier: OrderIdentifierInput;
};

export type MutationAdminRefundOrderArgs = {
  braintreeRefundInput?: InputMaybe<BraintreeRefundInput>;
  customerPublicId: Scalars["String"];
};

export type MutationAdminRefundOrderByAmountArgs = {
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByAmountInput;
};

export type MutationAdminRefundOrderByPercentageArgs = {
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByPercentageInput;
};

export type MutationAdminRefundOrderByQuantityArgs = {
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByQuantityInput;
};

export type MutationAdminReleaseOrderFromHoldingBinByIdentifierArgs = {
  orderIdentifier: OrderIdentifierInput;
};

export type MutationAdminTaxReviewArgs = {
  taxReviewInput?: InputMaybe<TaxReviewInput>;
};

export type MutationAdminUpdateCustomerSecretAndSettingsArgs = {
  customerPublicId: Scalars["String"];
  customerType: CustomerType;
  secretKey: Scalars["String"];
};

export type MutationAdminUpdateOrderStatusByIdentifierArgs = {
  orderIdentifier: OrderIdentifierInput;
};

export type MutationApiCredentialsCreateArgs = {
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
};

export type MutationBraintreePaymentCreateArgs = {
  braintreeCheckoutInput?: InputMaybe<BraintreeCheckoutInput>;
};

export type MutationCustomerProductCreateArgs = {
  createCustomerProductInput?: InputMaybe<CreateCustomerProductInput>;
};

export type MutationCustomerProductEditArgs = {
  editCustomerProductInput?: InputMaybe<EditCustomerProductInput>;
  id: Scalars["Int"];
};

export type MutationDashboardUserChangePasswordArgs = {
  changePasswordDashboardUserInput?: InputMaybe<ChangePasswordDashboardUserInput>;
  id: Scalars["Int"];
};

export type MutationDashboardUserCreateArgs = {
  createDashboardUserInput?: InputMaybe<DashboardUserInput>;
};

export type MutationDashboardUserDeleteArgs = {
  id: Scalars["Int"];
};

export type MutationDashboardUserEditArgs = {
  editDashboardUserInput?: InputMaybe<EditDashboardUserInput>;
  id: Scalars["Int"];
};

export type MutationDashboardUserUpdateSettingsArgs = {
  settings: Scalars["JSON"];
};

export type MutationEditOrganizationInformationArgs = {
  input: EditOrganizationInformationInput;
};

export type MutationOnboardCustomerArgs = {
  onboardingInput: OnboardingInput;
};

export type MutationOrderReprintCreateByIdentifierArgs = {
  createReprintInput: CreateReprintInputByIdentifier;
};

export type MutationOrderReprintCreateV2ByIdentifierArgs = {
  createReprintInputV2: CreateReprintInputV2ByIdentifier;
};

export type MutationPaymentMethodCreateArgs = {
  braintreePaymentMethodInput?: InputMaybe<BraintreePaymentMethodInput>;
};

export type MutationPaymentMethodCreateV2Args = {
  braintreePaymentMethodInput?: InputMaybe<BraintreePaymentMethodInput>;
};

export type MutationPaymentMethodDeleteArgs = {
  customerPublicId: Scalars["String"];
  paymentMethodToken: Scalars["String"];
};

export type MutationPaymentMethodEditArgs = {
  braintreePaymentMethodEditInput?: InputMaybe<BraintreePaymentMethodEditInput>;
};

export type MutationPaymentMethodEditV2Args = {
  braintreePaymentMethodEditInput?: InputMaybe<BraintreePaymentMethodEditInput>;
};

export type MutationSandboxPaymentNotificationArgs = {
  sandboxPaymentNotificationInput: SandboxPaymentNotificationInput;
};

export type MutationUploadCreateArgs = {
  createUploadInput?: InputMaybe<CreateUploadInput>;
};

export type MutationUploadedFileDeleteArgs = {
  id: Scalars["Int"];
};

export type OnboardingInput = {
  company: Scalars["String"];
  countryIso?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type OpenapiOrderItemProduct = {
  coverUrl?: InputMaybe<Scalars["String"]>;
  gutsUrl?: InputMaybe<Scalars["String"]>;
  imageUrl?: InputMaybe<Scalars["String"]>;
  pageCount?: InputMaybe<Scalars["Int"]>;
  printAssetUploadId?: InputMaybe<Scalars["String"]>;
};

export type OpenapiProductPricing = {
  __typename?: "OpenapiProductPricing";
  basePrice: Scalars["Float"];
  currency: SupportedCurrency;
  perPageCost: Scalars["Float"];
};

export type OpenapiProductResponse = {
  __typename?: "OpenapiProductResponse";
  description?: Maybe<Scalars["String"]>;
  enabled: Scalars["Boolean"];
  id: Scalars["Int"];
  name: Scalars["String"];
  openapiSku: Scalars["String"];
  productPricing?: Maybe<Array<OpenapiProductPricing>>;
  productSpecification: OpenapiProductSpecification;
  skuAttributes?: Maybe<Scalars["JSON"]>;
  uosMediaOption?: Maybe<Scalars["String"]>;
  uosOrientation?: Maybe<Scalars["String"]>;
  uosSku: Scalars["String"];
};

export type OpenapiProductSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<OpenapiProductSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/** ##### Dashboard user search */
export enum OpenapiProductSearchFields {
  Description = "description",
  Id = "id",
  Name = "name",
  OpenapiSku = "openapiSku",
  UosMediaOption = "uosMediaOption",
  UosOrientation = "uosOrientation",
  UosSku = "uosSku",
}

export type OpenapiProductSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: OpenapiProductSearchFields;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type OpenapiProductSpecification = {
  __typename?: "OpenapiProductSpecification";
  id: Scalars["Int"];
  md5Hash?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  processingSettings: Scalars["JSON"];
  processingTemplate: Scalars["String"];
  specification?: Maybe<Scalars["JSON"]>;
  type: Scalars["String"];
  version: Scalars["Int"];
};

export enum OpenapiProvidedShippingClassification {
  Economy = "ECONOMY",
  Express = "EXPRESS",
  Priority = "PRIORITY",
  Standard = "STANDARD",
}

export type OrderEventResponse = {
  __typename?: "OrderEventResponse";
  customerOrderId?: Maybe<Scalars["String"]>;
  data?: Maybe<Scalars["JSON"]>;
  eventTime?: Maybe<Scalars["String"]>;
  eventType?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Int"]>;
  shortDesc?: Maybe<Scalars["String"]>;
  webhookSourceName?: Maybe<Scalars["String"]>;
};

export type OrderIdentifierInput = {
  customerOrderId: Scalars["String"];
  customerPublicId: Scalars["String"];
};

export type OrderItemResponse = {
  __typename?: "OrderItemResponse";
  coverUri?: Maybe<Scalars["String"]>;
  customerOrderItemId?: Maybe<Scalars["String"]>;
  customerProduct?: Maybe<CustomerProductResponse>;
  destinationId?: Maybe<Scalars["Int"]>;
  gutsUri?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  imageUri?: Maybe<Scalars["String"]>;
  openapiProduct?: Maybe<OpenapiProductResponse>;
  orderItemStatus?: Maybe<OrderItemStatus>;
  pagecount?: Maybe<Scalars["Int"]>;
  pricingAlgorithm?: Maybe<Scalars["String"]>;
  pricingDetails?: Maybe<Scalars["JSON"]>;
  printAsset?: Maybe<PrintAssetResponse>;
  quantity?: Maybe<Scalars["Int"]>;
  unitPrice?: Maybe<Scalars["Float"]>;
  validationResult?: Maybe<Scalars["JSON"]>;
};

export enum OrderItemStatus {
  AwaitingProcessing = "AWAITING_PROCESSING",
  PreflightSuccess = "PREFLIGHT_SUCCESS",
  Processing = "PROCESSING",
  ProcessingFailed = "PROCESSING_FAILED",
  ProcessingSuccess = "PROCESSING_SUCCESS",
}

export type OrderLimitBulletinResponse = {
  __typename?: "OrderLimitBulletinResponse";
  configuredLimitQueueSize?: Maybe<Scalars["Int"]>;
  configuredMaxOrdersWithin24h?: Maybe<Scalars["Int"]>;
  isLimitQueueFull?: Maybe<Scalars["Boolean"]>;
  isOrdersLimitActive?: Maybe<Scalars["Boolean"]>;
  numOrdersInLimitQueue?: Maybe<Scalars["Int"]>;
  numOrdersReceivedUnderLimitLast24h?: Maybe<Scalars["Int"]>;
  numRejectedOrdersQueueFullLast7Days?: Maybe<Scalars["Int"]>;
};

export enum OrderLimiterStatus {
  LimitApplies = "LIMIT_APPLIES",
  NotLimitedReprint = "NOT_LIMITED_REPRINT",
  NotLimitedStaff = "NOT_LIMITED_STAFF",
  NoLimit = "NO_LIMIT",
}

export type OrderPricing = {
  __typename?: "OrderPricing";
  currency?: Maybe<SupportedCurrency>;
  itemsTotal?: Maybe<Scalars["Float"]>;
  orderTotal?: Maybe<Scalars["Float"]>;
  shippingTotal?: Maybe<Scalars["Float"]>;
  taxesTotal?: Maybe<Scalars["Float"]>;
};

export type OrderResponse = {
  __typename?: "OrderResponse";
  additionalPayload?: Maybe<Scalars["String"]>;
  callbacks?: Maybe<Array<CallbackResponse>>;
  canDoFullRefund?: Maybe<Scalars["Boolean"]>;
  canRefund?: Maybe<Scalars["Boolean"]>;
  canReprint?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["String"]>;
  currency?: Maybe<SupportedCurrency>;
  customer?: Maybe<CustomerResponse>;
  customerOrderId?: Maybe<Scalars["String"]>;
  destination?: Maybe<DestinationResponse>;
  id?: Maybe<Scalars["Int"]>;
  isSandbox: Scalars["Boolean"];
  lastStatusMessage?: Maybe<Scalars["String"]>;
  limiterQueued: Scalars["Boolean"];
  limiterSlaDelay: Scalars["Int"];
  limiterStatus?: Maybe<OrderLimiterStatus>;
  orderEvents?: Maybe<Array<OrderEventResponse>>;
  orderItems?: Maybe<Array<OrderItemResponse>>;
  orderPublicId?: Maybe<Scalars["String"]>;
  paymentMode?: Maybe<PaymentMode>;
  paymentStatus?: Maybe<PaymentStatus>;
  pricing?: Maybe<OrderPricing>;
  publicOrderStatus?: Maybe<PublicOrderStatus>;
  refunds?: Maybe<Array<PaymentResponse>>;
  remainingPossibleRefund?: Maybe<Scalars["Float"]>;
  reprintParentCustomerOrderId?: Maybe<Scalars["String"]>;
  reprintParentCustomerPublicId?: Maybe<Scalars["String"]>;
  salePayment?: Maybe<PaymentResponse>;
  shipments?: Maybe<Array<ShipmentResponse>>;
  status?: Maybe<OrderStatus>;
  submittedAt?: Maybe<Scalars["String"]>;
  uosOrderId?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["String"]>;
  validationResult?: Maybe<Scalars["JSON"]>;
  webhookUri?: Maybe<Scalars["String"]>;
};

export type OrderSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<OrderSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/**
 * ## Unfortunately you can't do much abstractions with gql types so we have to redefine them
 * # Order search
 */
export enum OrderSearchField {
  CreatedAt = "createdAt",
  CustomerOrderId = "customerOrderId",
  CustomerPublicId = "customerPublicId",
  Id = "id",
  IsSandbox = "isSandbox",
  PaymentStatus = "paymentStatus",
  Status = "status",
  SubmittedAt = "submittedAt",
  UpdatedAt = "updatedAt",
}

export type OrderSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: OrderSearchField;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export enum OrderStatus {
  AssetsProcessed = "ASSETS_PROCESSED",
  CancellationAttempted = "CANCELLATION_ATTEMPTED",
  CancellationRequestSentToPrinter = "CANCELLATION_REQUEST_SENT_TO_PRINTER",
  Cancelled = "CANCELLED",
  CancelledBeforeSubmission = "CANCELLED_BEFORE_SUBMISSION",
  Created = "CREATED",
  Exception = "EXCEPTION",
  Failed = "FAILED",
  PricingCompleted = "PRICING_COMPLETED",
  Received = "RECEIVED",
  ReceivedOverLimit = "RECEIVED_OVER_LIMIT",
  Rejected = "REJECTED",
  Shipped = "SHIPPED",
  Submitted = "SUBMITTED",
  Submitting = "SUBMITTING",
  WaitingForSubmission = "WAITING_FOR_SUBMISSION",
  WaitingForTaxes = "WAITING_FOR_TAXES",
  WaitingInHoldingBin = "WAITING_IN_HOLDING_BIN",
}

export type OrderStatusCount = {
  __typename?: "OrderStatusCount";
  count: Scalars["Int"];
  status: PublicOrderStatus;
};

export type OrdersByPublicStatusMetricsResponse = {
  __typename?: "OrdersByPublicStatusMetricsResponse";
  customerPublicId: Scalars["String"];
  numberOfDays: Scalars["Int"];
  ordersByPublicStatus: Array<SingleOrdersByPublicStatusMetricResponse>;
};

export type OrdersChartResponse = {
  __typename?: "OrdersChartResponse";
  availableYears: Array<Scalars["Int"]>;
  dataPoints: Array<MonthlyOrdersByStatusDataPoint>;
};

export type OrganizationInformation = {
  __typename?: "OrganizationInformation";
  country?: Maybe<Scalars["String"]>;
  hasBeenProvided: Scalars["Boolean"];
  size?: Maybe<Scalars["String"]>;
  website?: Maybe<Scalars["String"]>;
};

export type PagedApiCredentials = {
  __typename?: "PagedApiCredentials";
  data: Array<ApiCredentialsResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type PagedCustomerCommunications = {
  __typename?: "PagedCustomerCommunications";
  data: Array<CustomerCommunicationResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type PagedCustomerProducts = {
  __typename?: "PagedCustomerProducts";
  data: Array<CustomerProductResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type PagedCustomers = {
  __typename?: "PagedCustomers";
  data: Array<CustomerResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type PagedDashboardUsers = {
  __typename?: "PagedDashboardUsers";
  data: Array<DashboardUserResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type PagedOpenApiProducts = {
  __typename?: "PagedOpenApiProducts";
  data: Array<OpenapiProductResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type PagedOrders = {
  __typename?: "PagedOrders";
  data: Array<OrderResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type PagedPaymentSearchResponse = {
  __typename?: "PagedPaymentSearchResponse";
  data: Array<PaymentResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type PagedPrintAssets = {
  __typename?: "PagedPrintAssets";
  data: Array<PrintAssetResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export type PagedUploadedFiles = {
  __typename?: "PagedUploadedFiles";
  data: Array<UploadedFileResponse>;
  nextOffset?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  prevOffset?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
};

export enum PaymentMode {
  DailyCharge = "DAILY_CHARGE",
  ExternallyPaid = "EXTERNALLY_PAID",
  Immediate = "IMMEDIATE",
}

export enum PaymentRefundStatus {
  Failed = "FAILED",
  Pending = "PENDING",
  SuccessfulRefund = "SUCCESSFUL_REFUND",
  SuccessfulVoid = "SUCCESSFUL_VOID",
}

export type PaymentResponse = {
  __typename?: "PaymentResponse";
  amount?: Maybe<Scalars["Float"]>;
  braintreeTransactionId?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["String"]>;
  currency?: Maybe<SupportedCurrency>;
  customerPublicId?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Int"]>;
  lastRefundAttemptAt?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  paidOrders?: Maybe<Array<OrderResponse>>;
  paymentInfo?: Maybe<Scalars["JSON"]>;
  paymentMethodLabel?: Maybe<Scalars["String"]>;
  refundDetails?: Maybe<RefundDetails>;
  refundStatus?: Maybe<PaymentRefundStatus>;
  refundedOrder?: Maybe<OrderResponse>;
  saleParentPaymentId?: Maybe<Scalars["Int"]>;
  transactionType?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars["String"]>;
};

export type PaymentSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<PaymentSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/** ##### Payment search */
export enum PaymentSearchFields {
  Amount = "amount",
  BraintreeTransactionId = "braintreeTransactionId",
  CreatedAt = "createdAt",
  CustomerPublicId = "customerPublicId",
  Id = "id",
  TransactionType = "transactionType",
  UpdatedAt = "updatedAt",
}

export type PaymentSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: PaymentSearchFields;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export enum PaymentStatus {
  ExternallyPaid = "EXTERNALLY_PAID",
  NoPaymentStaffOrder = "NO_PAYMENT_STAFF_ORDER",
  Paid = "PAID",
  PaymentPending = "PAYMENT_PENDING",
  Unpaid = "UNPAID",
}

export type PaymentsChartResponse = {
  __typename?: "PaymentsChartResponse";
  availableYears: Array<Scalars["Int"]>;
  dataPoints: Array<MonthlyPaymentDataPoint>;
  nextChargeDate?: Maybe<Scalars["String"]>;
};

export type PaymentsMetricsResponse = {
  __typename?: "PaymentsMetricsResponse";
  customerPublicId: Scalars["String"];
  days: Array<SinglePaymentMetricsResponse>;
  numberOfDays: Scalars["Int"];
};

export type PrintAssetResponse = {
  __typename?: "PrintAssetResponse";
  customer?: Maybe<CustomerResponse>;
  id: Scalars["Int"];
  orderItems?: Maybe<Array<OrderItemResponse>>;
  preflightOutputFiles?: Maybe<Scalars["JSON"]>;
  previews?: Maybe<Scalars["JSON"]>;
  printAssetUploadId?: Maybe<Scalars["String"]>;
  report?: Maybe<Scalars["JSON"]>;
  status?: Maybe<PrintAssetStatus>;
  updatedAt?: Maybe<Scalars["String"]>;
};

export type PrintAssetSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<PrintAssetSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/** ##### Print asset search */
export enum PrintAssetSearchFields {
  CustomerPublicId = "customerPublicId",
  Id = "id",
  PrintAssetUploadId = "printAssetUploadId",
  Status = "status",
  UpdatedAt = "updatedAt",
}

export type PrintAssetSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: PrintAssetSearchFields;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export enum PrintAssetStatus {
  AwaitingInput = "AWAITING_INPUT",
  Enqueued = "ENQUEUED",
  Failure = "FAILURE",
  Invalid = "INVALID",
  Processing = "PROCESSING",
  Purged = "PURGED",
  Success = "SUCCESS",
}

export enum PublicOrderStatus {
  CancellationRequested = "CANCELLATION_REQUESTED",
  Cancelled = "CANCELLED",
  Exception = "EXCEPTION",
  Failed = "FAILED",
  Printing = "PRINTING",
  Queued = "QUEUED",
  Received = "RECEIVED",
  Rejected = "REJECTED",
  Shipped = "SHIPPED",
  Validating = "VALIDATING",
  ValidAwaitingPayment = "VALID_AWAITING_PAYMENT",
  ValidHoldingBin = "VALID_HOLDING_BIN",
}

export type Query = {
  __typename?: "Query";
  adminConfiguration?: Maybe<AdminConfigResponse>;
  adminListCustomers?: Maybe<Array<CustomerResponse>>;
  adminSearchCustomerCommunications: PagedCustomerCommunications;
  adminSearchCustomers: PagedCustomers;
  apiCredentials: PagedApiCredentials;
  bulletins?: Maybe<BulletinResponse>;
  calculateRefund: RefundCalculationResponse;
  calculateRefundByAmount: RefundCalculationResponse;
  calculateRefundByPercentage: RefundCalculationResponse;
  calculateRefundByQuantity: RefundCalculationResponse;
  customer: CustomerResponse;
  customerCommunication: CustomerCommunicationResponse;
  customerProduct: CustomerProductResponse;
  customerProducts: PagedCustomerProducts;
  dailyMetrics?: Maybe<DailyOrdersMetricsResponse>;
  dailyPaymentMetrics?: Maybe<PaymentsMetricsResponse>;
  dashboardUser: DashboardUserResponse;
  dashboardUserCurrent: DashboardUserResponse;
  dashboardUsers: PagedDashboardUsers;
  getNextChargeTime?: Maybe<Scalars["String"]>;
  listApiCredentials: Array<ApiCredentialsResponse>;
  listCustomerProducts: Array<CustomerProductResponse>;
  listOpenApiProducts: Array<OpenapiProductResponse>;
  listOrdersForPayment?: Maybe<Array<OrderResponse>>;
  listPaymentMethods: Array<BraintreePaymentMethodResponse>;
  openapiProduct: OpenapiProductResponse;
  openapiProductExists: Scalars["Boolean"];
  openapiProducts: PagedOpenApiProducts;
  orderByIdentifier: OrderResponse;
  orderItem: OrderItemResponse;
  orders: PagedOrders;
  ordersByPublicStatusMetrics?: Maybe<OrdersByPublicStatusMetricsResponse>;
  ordersChart?: Maybe<OrdersChartResponse>;
  payment: PaymentResponse;
  paymentByTransactionId: PaymentResponse;
  payments: PagedPaymentSearchResponse;
  paymentsChart?: Maybe<PaymentsChartResponse>;
  printAsset: PrintAssetResponse;
  printAssets: PagedPrintAssets;
  uploadFilesPollByCollection?: Maybe<Array<Maybe<UploadedFileResponse>>>;
  uploadedFile: UploadedFileResponse;
  uploadedFiles: PagedUploadedFiles;
};

export type QueryAdminListCustomersArgs = {
  generalInput?: InputMaybe<Scalars["String"]>;
};

export type QueryAdminSearchCustomerCommunicationsArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<CustomerCommunicationSearch>;
};

export type QueryAdminSearchCustomersArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<CustomerSearch>;
};

export type QueryApiCredentialsArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<ApiCredentialSearch>;
};

export type QueryCalculateRefundArgs = {
  customerPublicId: Scalars["String"];
  input: BraintreeRefundInput;
};

export type QueryCalculateRefundByAmountArgs = {
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByAmountInput;
};

export type QueryCalculateRefundByPercentageArgs = {
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByPercentageInput;
};

export type QueryCalculateRefundByQuantityArgs = {
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByQuantityInput;
};

export type QueryCustomerArgs = {
  customerPublicId: Scalars["String"];
};

export type QueryCustomerCommunicationArgs = {
  id: Scalars["Int"];
};

export type QueryCustomerProductArgs = {
  id: Scalars["Int"];
};

export type QueryCustomerProductsArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<CustomerProductSearch>;
};

export type QueryDailyMetricsArgs = {
  customerPublicId: Scalars["String"];
  numberOfDays: Scalars["Int"];
};

export type QueryDailyPaymentMetricsArgs = {
  customerPublicId: Scalars["String"];
  numberOfDays: Scalars["Int"];
};

export type QueryDashboardUserArgs = {
  id?: InputMaybe<Scalars["Int"]>;
};

export type QueryDashboardUsersArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<DashboardUserSearch>;
};

export type QueryGetNextChargeTimeArgs = {
  customerPublicId: Scalars["String"];
};

export type QueryListOpenApiProductsArgs = {
  hideAlreadyAssociatedProducts?: InputMaybe<Scalars["Boolean"]>;
};

export type QueryListOrdersForPaymentArgs = {
  customerPublicId: Scalars["String"];
};

export type QueryListPaymentMethodsArgs = {
  customerPublicId: Scalars["String"];
};

export type QueryOpenapiProductArgs = {
  id: Scalars["Int"];
};

export type QueryOpenapiProductExistsArgs = {
  sku: Scalars["String"];
};

export type QueryOpenapiProductsArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<OpenapiProductSearch>;
};

export type QueryOrderByIdentifierArgs = {
  isSandbox?: Scalars["Boolean"];
  orderIdentifier: OrderIdentifierInput;
};

export type QueryOrderItemArgs = {
  id: Scalars["Int"];
};

export type QueryOrdersArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<OrderSearch>;
};

export type QueryOrdersByPublicStatusMetricsArgs = {
  customerPublicId: Scalars["String"];
  numberOfDays: Scalars["Int"];
};

export type QueryOrdersChartArgs = {
  isSandbox: Scalars["Boolean"];
  timezone: Scalars["String"];
  year: Scalars["Int"];
};

export type QueryPaymentArgs = {
  id?: InputMaybe<Scalars["Int"]>;
};

export type QueryPaymentByTransactionIdArgs = {
  braintreeTransactionId?: InputMaybe<Scalars["String"]>;
};

export type QueryPaymentsArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<PaymentSearch>;
};

export type QueryPaymentsChartArgs = {
  isSandbox: Scalars["Boolean"];
  timezone: Scalars["String"];
  year: Scalars["Int"];
};

export type QueryPrintAssetArgs = {
  id: Scalars["Int"];
};

export type QueryPrintAssetsArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<PrintAssetSearch>;
};

export type QueryUploadFilesPollByCollectionArgs = {
  collectionId: Scalars["String"];
  customerPublicId: Scalars["String"];
};

export type QueryUploadedFileArgs = {
  id: Scalars["Int"];
};

export type QueryUploadedFilesArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<UploadedFileSearch>;
};

export type RefundCalculationResponse = {
  __typename?: "RefundCalculationResponse";
  lineItems: Array<RefundLineItemResponse>;
  refundSubtotal: Scalars["Float"];
  refundTax: Scalars["Float"];
  totalRefund: Scalars["Float"];
};

export type RefundDetails = {
  __typename?: "RefundDetails";
  itemsRefundAmount: Scalars["Float"];
  reason?: Maybe<RefundReason>;
  reasonNote?: Maybe<Scalars["String"]>;
  refundedBy?: Maybe<UserActorResponse>;
  shippingRefundAmount: Scalars["Float"];
  strategy: BraintreeRefundStrategy;
  taxesRefundAmount: Scalars["Float"];
};

export type RefundItem = {
  id?: InputMaybe<Scalars["Int"]>;
  quantity: Scalars["Int"];
};

export type RefundItemAmount = {
  amount: Scalars["Float"];
  id?: InputMaybe<Scalars["Int"]>;
};

export type RefundItemPercentage = {
  id?: InputMaybe<Scalars["Int"]>;
  percentage: Scalars["Float"];
};

export type RefundItemQuantity = {
  id?: InputMaybe<Scalars["Int"]>;
  quantity: Scalars["Int"];
};

export type RefundLineItemResponse = {
  __typename?: "RefundLineItemResponse";
  /** @deprecated Use id; will be removed after contract phase */
  customerOrderItemId: Scalars["ID"];
  id: Scalars["Int"];
  quantity: Scalars["Int"];
  refundAmount: Scalars["Float"];
  refundTax: Scalars["Float"];
  unitPrice: Scalars["Float"];
};

export enum RefundReason {
  /** Binding */
  BadSaddleStitching = "BAD_SADDLE_STITCHING",
  BrokenSpine = "BROKEN_SPINE",
  /** Print */
  ColorOutputVariance = "COLOR_OUTPUT_VARIANCE",
  /** Not Mine */
  CompleteWrongOrder = "COMPLETE_WRONG_ORDER",
  CorrectCoverWrongText = "CORRECT_COVER_WRONG_TEXT",
  CrookedCover = "CROOKED_COVER",
  /** Courier */
  DamagedInTransit = "DAMAGED_IN_TRANSIT",
  /** Shipping */
  DamageImproperPackaging = "DAMAGE_IMPROPER_PACKAGING",
  DuplicatePages = "DUPLICATE_PAGES",
  EndsheetsAlignment = "ENDSHEETS_ALIGNMENT",
  EndsheetsBubbleWrinkle = "ENDSHEETS_BUBBLE_WRINKLE",
  EndsheetsWrong = "ENDSHEETS_WRONG",
  ExcessiveGlueResidue = "EXCESSIVE_GLUE_RESIDUE",
  Ghosting = "GHOSTING",
  IncorrectDamagedWireO = "INCORRECT_DAMAGED_WIRE_O",
  IncorrectFoil = "INCORRECT_FOIL",
  IncorrectQuantity = "INCORRECT_QUANTITY",
  /** Finishing */
  IncorrectScoreLine = "INCORRECT_SCORE_LINE",
  IncorrectSubstrate = "INCORRECT_SUBSTRATE",
  InkCrackingInGutterLayflat = "INK_CRACKING_IN_GUTTER_LAYFLAT",
  LaminationBubbles = "LAMINATION_BUBBLES",
  LaminationDelamination = "LAMINATION_DELAMINATION",
  LaminationWrong = "LAMINATION_WRONG",
  LostInTransit = "LOST_IN_TRANSIT",
  MisregistrationColorToColor = "MISREGISTRATION_COLOR_TO_COLOR",
  MisregistrationFrontToBack = "MISREGISTRATION_FRONT_TO_BACK",
  MissingPages = "MISSING_PAGES",
  /** Customer */
  NoCredit = "NO_CREDIT",
  /** Escape hatch — requires reasonNote */
  Other = "OTHER",
  PackageNotScanned = "PACKAGE_NOT_SCANNED",
  PagesFallingOut = "PAGES_FALLING_OUT",
  PagesNotGluedCorrectlyLayflat = "PAGES_NOT_GLUED_CORRECTLY_LAYFLAT",
  PartialWrongOrder = "PARTIAL_WRONG_ORDER",
  PhysicalDamage = "PHYSICAL_DAMAGE",
  PurGlueSpikes = "PUR_GLUE_SPIKES",
  ReceivedAdditionalItems = "RECEIVED_ADDITIONAL_ITEMS",
  ReturnedToSender = "RETURNED_TO_SENDER",
  SlipsheetBoundInBook = "SLIPSHEET_BOUND_IN_BOOK",
  SpotsVoidsBandingSmears = "SPOTS_VOIDS_BANDING_SMEARS",
  TrimmingImageOffCenter = "TRIMMING_IMAGE_OFF_CENTER",
  TrimmingIncorrectDie = "TRIMMING_INCORRECT_DIE",
  TrimmingRoughUnclean = "TRIMMING_ROUGH_UNCLEAN",
  TrimmingWrongDimensions = "TRIMMING_WRONG_DIMENSIONS",
  UvInconsistent = "UV_INCONSISTENT",
  UvMissing = "UV_MISSING",
  WavyPages = "WAVY_PAGES",
  WrinkledCreasedPages = "WRINKLED_CREASED_PAGES",
  WrongCoverCorrectText = "WRONG_COVER_CORRECT_TEXT",
  WrongLinenType = "WRONG_LINEN_TYPE",
  WrongOrientation = "WRONG_ORIENTATION",
  WrongPageOrder = "WRONG_PAGE_ORDER",
  WrongSpineSize = "WRONG_SPINE_SIZE",
}

export type ReprintReplacedAssets = {
  orderItemId?: InputMaybe<Scalars["Int"]>;
  replacedProduct?: InputMaybe<OpenapiOrderItemProduct>;
};

export type SandboxPaymentNotificationInput = {
  success: Scalars["Boolean"];
};

export type SandboxPaymentNotificationResponse = {
  __typename?: "SandboxPaymentNotificationResponse";
  message: Scalars["String"];
  success: Scalars["Boolean"];
};

export enum SearchCondition {
  Between = "BETWEEN",
  Contains = "CONTAINS",
  Equals = "EQUALS",
  In = "IN",
  NotEquals = "NOT_EQUALS",
}

export type SearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: Scalars["String"];
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type SearchInputV2 = {
  search?: InputMaybe<Array<InputMaybe<SearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

export type ShipmentResponse = {
  __typename?: "ShipmentResponse";
  destination?: Maybe<DestinationResponse>;
  id: Scalars["Int"];
  isFinalShipment?: Maybe<Scalars["Boolean"]>;
  masterTrackingNumber?: Maybe<Scalars["String"]>;
  orderItems?: Maybe<Array<OrderItemResponse>>;
  rawShipmentData?: Maybe<Scalars["JSON"]>;
  secondaryTrackingNumber?: Maybe<Scalars["String"]>;
  shippedDate?: Maybe<Scalars["String"]>;
  shippingMethodCode?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  trackingNumber?: Maybe<Scalars["String"]>;
  uosShipmentId?: Maybe<Scalars["String"]>;
};

export type SingleDayMetricsResponse = {
  __typename?: "SingleDayMetricsResponse";
  createdDay: Scalars["String"];
  numCreatedOrders: Scalars["Int"];
  sumOrderTotals: Scalars["Float"];
};

export type SingleOrdersByPublicStatusMetricResponse = {
  __typename?: "SingleOrdersByPublicStatusMetricResponse";
  numOrders: Scalars["Int"];
  publicStatus: PublicOrderStatus;
};

export type SinglePaymentMetricsResponse = {
  __typename?: "SinglePaymentMetricsResponse";
  createdDay: Scalars["String"];
  sumRefundTotals: Scalars["Float"];
  sumSaleTotals: Scalars["Float"];
};

export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}

export type SortInput = {
  by?: InputMaybe<Scalars["String"]>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum SupportedCurrency {
  Aud = "AUD",
  Cad = "CAD",
  Eur = "EUR",
  Gbp = "GBP",
  Usd = "USD",
}

export type TaxReviewInput = {
  approved: Scalars["Boolean"];
  customerPublicId: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
};

export type TaxReviewResponse = {
  __typename?: "TaxReviewResponse";
  customer: CustomerResponse;
  message: Scalars["String"];
  taxApprovalChanged: Scalars["Boolean"];
};

export enum TransactionType {
  Refund = "REFUND",
  Sale = "SALE",
  Void = "VOID",
}

export type UploadServiceV2CollectionsStatusResponse = {
  __typename?: "UploadServiceV2CollectionsStatusResponse";
  collectionId: Scalars["String"];
  collectionType?: Maybe<Scalars["String"]>;
  fileCount: Scalars["Int"];
  finishFileUrl: Scalars["String"];
  uploadExpiration?: Maybe<Scalars["String"]>;
  uploadFiles?: Maybe<Array<Maybe<UploadServiceV2FileStatusResponse>>>;
};

export type UploadServiceV2FileStatusResponse = {
  __typename?: "UploadServiceV2FileStatusResponse";
  collectionId?: Maybe<Scalars["String"]>;
  contentType?: Maybe<Scalars["String"]>;
  externalFileId?: Maybe<Scalars["String"]>;
  fileId?: Maybe<Scalars["String"]>;
  fileName?: Maybe<Scalars["String"]>;
  fileSize?: Maybe<Scalars["Int"]>;
  multipartUpload?: Maybe<UploadServiceV2MultipartUpload>;
};

export type UploadServiceV2MultipartUpload = {
  __typename?: "UploadServiceV2MultipartUpload";
  key?: Maybe<Scalars["String"]>;
  parts?: Maybe<Array<Maybe<UploadServiceV2UploadPart>>>;
  uploadId?: Maybe<Scalars["String"]>;
};

export type UploadServiceV2UploadPart = {
  __typename?: "UploadServiceV2UploadPart";
  PartNumber?: Maybe<Scalars["Int"]>;
  uploadUrl?: Maybe<Scalars["String"]>;
};

export type UploadedFileDeleteResponse = {
  __typename?: "UploadedFileDeleteResponse";
  message?: Maybe<Scalars["String"]>;
};

export type UploadedFileResponse = {
  __typename?: "UploadedFileResponse";
  collectionId: Scalars["String"];
  contentType: Scalars["String"];
  createdAt: Scalars["String"];
  customer: CustomerResponse;
  description?: Maybe<Scalars["String"]>;
  fileName: Scalars["String"];
  id: Scalars["Int"];
  isTaxDocument?: Maybe<Scalars["Boolean"]>;
  status: UploadedFileStatus;
  updatedAt: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
};

export type UploadedFileSearch = {
  generalInput?: InputMaybe<Scalars["String"]>;
  inputs?: InputMaybe<Array<InputMaybe<UploadedFileSearchInput>>>;
  sort?: InputMaybe<SortInput>;
};

/** ##### Uploaded file search */
export enum UploadedFileSearchFields {
  CollectionId = "collectionId",
  CreatedAt = "createdAt",
  CustomerPublicId = "customerPublicId",
  FileName = "fileName",
  FileType = "fileType",
  Id = "id",
  IsTaxDocument = "isTaxDocument",
  Status = "status",
  UpdatedAt = "updatedAt",
}

export type UploadedFileSearchInput = {
  condition?: InputMaybe<SearchCondition>;
  field: UploadedFileSearchFields;
  firstValue?: InputMaybe<Scalars["String"]>;
  secondValue?: InputMaybe<Scalars["String"]>;
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export enum UploadedFileStatus {
  Failure = "FAILURE",
  Finished = "FINISHED",
  Started = "STARTED",
}

export type UploadingFilesInput = {
  contentType: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  fileName: Scalars["String"];
  fileSize: Scalars["Int"];
  taxDocument: Scalars["Boolean"];
};

/**
 * A user who performed an action — minimal "who did this" projection,
 * intentionally narrower than DashboardUserResponse (no role, disabled,
 * sub, or settings).
 */
export type UserActorResponse = {
  __typename?: "UserActorResponse";
  email: Scalars["String"];
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
};

export type OrderItemFieldsFragment = {
  __typename?: "OrderItemResponse";
  id: number;
  orderItemStatus?: OrderItemStatus | null;
  pagecount?: number | null;
  imageUri?: string | null;
  quantity?: number | null;
  unitPrice?: number | null;
  validationResult?: any | null;
  openapiProduct?: { __typename?: "OpenapiProductResponse"; openapiSku: string } | null;
  customerProduct?: {
    __typename?: "CustomerProductResponse";
    name?: string | null;
    description?: string | null;
  } | null;
  printAsset?: {
    __typename?: "PrintAssetResponse";
    status?: PrintAssetStatus | null;
    preflightOutputFiles?: any | null;
  } | null;
};

export type OrderRowFieldsFragment = {
  __typename?: "OrderResponse";
  customerOrderId?: string | null;
  orderPublicId?: string | null;
  publicOrderStatus?: PublicOrderStatus | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  submittedAt?: string | null;
  paymentStatus?: PaymentStatus | null;
  currency?: SupportedCurrency | null;
  lastStatusMessage?: string | null;
  isSandbox: boolean;
  customer?: { __typename?: "CustomerResponse"; publicId: string; organizationName?: string | null } | null;
  pricing?: {
    __typename?: "OrderPricing";
    currency?: SupportedCurrency | null;
    itemsTotal?: number | null;
    orderTotal?: number | null;
    shippingTotal?: number | null;
    taxesTotal?: number | null;
  } | null;
};

export type CreateApiCredentialMutationVariables = Exact<{
  input?: InputMaybe<ApiCredentialsInput>;
}>;

export type CreateApiCredentialMutation = {
  __typename?: "Mutation";
  apiCredentialsCreate: { __typename?: "ApiCredentialsResponse"; id: number };
};

export type AdminRefundOrderMutationVariables = Exact<{
  input?: InputMaybe<BraintreeRefundInput>;
  customerPublicId: Scalars["String"];
}>;

export type AdminRefundOrderMutation = {
  __typename?: "Mutation";
  adminRefundOrder: { __typename?: "BraintreeRefundResponse"; message?: string | null };
};

export type AdminRefundOrderByAmountMutationVariables = Exact<{
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByAmountInput;
}>;

export type AdminRefundOrderByAmountMutation = {
  __typename?: "Mutation";
  adminRefundOrderByAmount: { __typename?: "BraintreeRefundResponse"; message?: string | null };
};

export type AdminRefundOrderByPercentageMutationVariables = Exact<{
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByPercentageInput;
}>;

export type AdminRefundOrderByPercentageMutation = {
  __typename?: "Mutation";
  adminRefundOrderByPercentage: { __typename?: "BraintreeRefundResponse"; message?: string | null };
};

export type AdminRefundOrderByQuantityMutationVariables = Exact<{
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByQuantityInput;
}>;

export type AdminRefundOrderByQuantityMutation = {
  __typename?: "Mutation";
  adminRefundOrderByQuantity: { __typename?: "BraintreeRefundResponse"; message?: string | null };
};

export type CreateBraintreePaymentMutationVariables = Exact<{
  input?: InputMaybe<BraintreeCheckoutInput>;
}>;

export type CreateBraintreePaymentMutation = {
  __typename?: "Mutation";
  braintreePaymentCreate: {
    __typename?: "BraintreeCheckoutResponse";
    message?: string | null;
    braintreeTransactionId?: string | null;
  };
};

export type CreateCustomerProductMutationVariables = Exact<{
  input?: InputMaybe<CreateCustomerProductInput>;
}>;

export type CreateCustomerProductMutation = {
  __typename?: "Mutation";
  customerProductCreate: { __typename?: "CustomerProductResponse"; id: number };
};

export type EditCustomerProductMutationVariables = Exact<{
  id: Scalars["Int"];
  input?: InputMaybe<EditCustomerProductInput>;
}>;

export type EditCustomerProductMutation = {
  __typename?: "Mutation";
  customerProductEdit: { __typename?: "CustomerProductResponse"; id: number };
};

export type AdminCreateCustomerMutationVariables = Exact<{
  input?: InputMaybe<CustomerInput>;
}>;

export type AdminCreateCustomerMutation = {
  __typename?: "Mutation";
  adminCreateCustomer: { __typename?: "CustomerResponse"; id: number };
};

export type AdminEditCustomerMutationVariables = Exact<{
  input?: InputMaybe<EditCustomerInput>;
}>;

export type AdminEditCustomerMutation = {
  __typename?: "Mutation";
  adminEditCustomer: { __typename?: "CustomerResponse"; id: number };
};

export type AdminEditCustomerLimitsMutationVariables = Exact<{
  customerPublicId: Scalars["String"];
  input?: InputMaybe<CustomerSettingsOrdersLimit>;
}>;

export type AdminEditCustomerLimitsMutation = {
  __typename?: "Mutation";
  adminEditCustomerLimits: { __typename?: "CustomerResponse"; id: number };
};

export type AdminUpdateCustomerSecretAndSettingsMutationVariables = Exact<{
  customerPublicId: Scalars["String"];
  customerType: CustomerType;
  secretKey: Scalars["String"];
}>;

export type AdminUpdateCustomerSecretAndSettingsMutation = {
  __typename?: "Mutation";
  adminUpdateCustomerSecretAndSettings: {
    __typename?: "CustomerResponse";
    publicId: string;
    secretKey?: string | null;
    settings?: {
      __typename?: "CustomerSettings";
      payments?: CustomerSettingsPayments | null;
      pricing?: CustomerSettingsPricing | null;
    } | null;
  };
};

export type EditOrganizationInformationMutationVariables = Exact<{
  input: EditOrganizationInformationInput;
}>;

export type EditOrganizationInformationMutation = {
  __typename?: "Mutation";
  editOrganizationInformation: {
    __typename?: "CustomerResponse";
    publicId: string;
    organizationName?: string | null;
    organization: {
      __typename?: "OrganizationInformation";
      website?: string | null;
      size?: string | null;
      country?: string | null;
    };
  };
};

export type OnboardCustomerMutationVariables = Exact<{
  input: OnboardingInput;
}>;

export type OnboardCustomerMutation = {
  __typename?: "Mutation";
  onboardCustomer?: { __typename?: "CustomerResponse"; isOnboardingComplete?: boolean | null } | null;
};

export type ChangeDashboardUserPasswordMutationVariables = Exact<{
  id: Scalars["Int"];
  input?: InputMaybe<ChangePasswordDashboardUserInput>;
}>;

export type ChangeDashboardUserPasswordMutation = {
  __typename?: "Mutation";
  dashboardUserChangePassword: { __typename?: "DashboardUserResponse"; id: number };
};

export type CreateDashboardUserMutationVariables = Exact<{
  input?: InputMaybe<DashboardUserInput>;
}>;

export type CreateDashboardUserMutation = {
  __typename?: "Mutation";
  dashboardUserCreate: { __typename?: "DashboardUserResponse"; id: number };
};

export type DeleteDashboardUserMutationVariables = Exact<{
  id: Scalars["Int"];
}>;

export type DeleteDashboardUserMutation = { __typename?: "Mutation"; dashboardUserDelete: string };

export type EditDashboardUserMutationVariables = Exact<{
  id: Scalars["Int"];
  input?: InputMaybe<EditDashboardUserInput>;
}>;

export type EditDashboardUserMutation = {
  __typename?: "Mutation";
  dashboardUserEdit: { __typename?: "DashboardUserResponse"; id: number };
};

export type UpdateDashboardUserSettingsMutationVariables = Exact<{
  settings: Scalars["JSON"];
}>;

export type UpdateDashboardUserSettingsMutation = {
  __typename?: "Mutation";
  dashboardUserUpdateSettings: {
    __typename?: "DashboardUserResponse";
    id: number;
    username?: string | null;
    settings?: any | null;
  };
};

export type AdminCancelOrderMutationVariables = Exact<{
  input: AdminCancelOrderInputV2;
}>;

export type AdminCancelOrderMutation = {
  __typename?: "Mutation";
  adminCancelOrderByIdentifierV2?: { __typename?: "OrderResponse"; customerOrderId?: string | null } | null;
};

export type AdminCancelOrderV2MutationVariables = Exact<{
  input: AdminCancelOrderInputV2;
}>;

export type AdminCancelOrderV2Mutation = {
  __typename?: "Mutation";
  adminCancelOrderByIdentifierV2?: { __typename?: "OrderResponse"; customerOrderId?: string | null } | null;
};

export type AdminOverridePaymentStatusMutationVariables = Exact<{
  input: AdminOverridePaymentStatusInput;
}>;

export type AdminOverridePaymentStatusMutation = {
  __typename?: "Mutation";
  adminOverridePaymentStatus?: {
    __typename?: "OrderResponse";
    customerOrderId?: string | null;
    paymentStatus?: PaymentStatus | null;
  } | null;
};

export type AdminRedriveOrderMutationVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
}>;

export type AdminRedriveOrderMutation = {
  __typename?: "Mutation";
  adminRedriveOrderByIdentifier?: {
    __typename?: "OrderResponse";
    customerOrderId?: string | null;
    status?: OrderStatus | null;
  } | null;
};

export type AdminReleaseFromHoldingBinMutationVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
}>;

export type AdminReleaseFromHoldingBinMutation = {
  __typename?: "Mutation";
  adminReleaseOrderFromHoldingBinByIdentifier?: {
    __typename?: "OrderResponse";
    customerOrderId?: string | null;
  } | null;
};

export type AdminUpdateOrderStatusMutationVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
}>;

export type AdminUpdateOrderStatusMutation = {
  __typename?: "Mutation";
  adminUpdateOrderStatusByIdentifier?: { __typename?: "OrderResponse"; customerOrderId?: string | null } | null;
};

export type ReprintOrderMutationVariables = Exact<{
  input: CreateReprintInputByIdentifier;
}>;

export type ReprintOrderMutation = {
  __typename?: "Mutation";
  orderReprintCreateByIdentifier: {
    __typename?: "CreateOrderResponse";
    customerOrderId: string;
    validations?: any | null;
  };
};

export type ReprintOrderV2MutationVariables = Exact<{
  input: CreateReprintInputV2ByIdentifier;
}>;

export type ReprintOrderV2Mutation = {
  __typename?: "Mutation";
  orderReprintCreateV2ByIdentifier: {
    __typename?: "CreateOrderResponse";
    customerOrderId: string;
    validations?: any | null;
  };
};

export type CreatePaymentMethodMutationVariables = Exact<{
  input?: InputMaybe<BraintreePaymentMethodInput>;
}>;

export type CreatePaymentMethodMutation = {
  __typename?: "Mutation";
  paymentMethodCreateV2:
    | {
        __typename: "BraintreePaymentMethodRejection";
        message: string;
        verification?: {
          __typename?: "BraintreeVerification";
          avsPostalCodeResponseCode?: string | null;
          avsStreetAddressResponseCode?: string | null;
        } | null;
      }
    | { __typename: "BraintreePaymentMethodResponse"; token?: string | null };
};

export type DeletePaymentMethodMutationVariables = Exact<{
  paymentMethodToken: Scalars["String"];
  customerPublicId: Scalars["String"];
}>;

export type DeletePaymentMethodMutation = {
  __typename?: "Mutation";
  paymentMethodDelete?: { __typename?: "BraintreeResponse"; message?: string | null } | null;
};

export type EditPaymentMethodMutationVariables = Exact<{
  input?: InputMaybe<BraintreePaymentMethodEditInput>;
}>;

export type EditPaymentMethodMutation = {
  __typename?: "Mutation";
  paymentMethodEdit: { __typename?: "BraintreePaymentMethodResponse"; token?: string | null };
};

export type EditPaymentMethodV2MutationVariables = Exact<{
  input?: InputMaybe<BraintreePaymentMethodEditInput>;
}>;

export type EditPaymentMethodV2Mutation = {
  __typename?: "Mutation";
  paymentMethodEditV2:
    | {
        __typename: "BraintreePaymentMethodRejection";
        message: string;
        verification?: {
          __typename?: "BraintreeVerification";
          avsPostalCodeResponseCode?: string | null;
          avsStreetAddressResponseCode?: string | null;
        } | null;
      }
    | { __typename: "BraintreePaymentMethodResponse"; token?: string | null };
};

export type SandboxPaymentNotificationMutationVariables = Exact<{
  input: SandboxPaymentNotificationInput;
}>;

export type SandboxPaymentNotificationMutation = {
  __typename?: "Mutation";
  sandboxPaymentNotification: { __typename?: "SandboxPaymentNotificationResponse"; message: string; success: boolean };
};

export type AdminTaxReviewMutationVariables = Exact<{
  input?: InputMaybe<TaxReviewInput>;
}>;

export type AdminTaxReviewMutation = {
  __typename?: "Mutation";
  adminTaxReview?: { __typename?: "TaxReviewResponse"; message: string; taxApprovalChanged: boolean } | null;
};

export type UploadedFileDeleteMutationVariables = Exact<{
  id: Scalars["Int"];
}>;

export type UploadedFileDeleteMutation = {
  __typename?: "Mutation";
  uploadedFileDelete?: { __typename?: "UploadedFileDeleteResponse"; message?: string | null } | null;
};

export type CreateUploadMutationVariables = Exact<{
  input?: InputMaybe<CreateUploadInput>;
}>;

export type CreateUploadMutation = {
  __typename?: "Mutation";
  uploadCreate?: {
    __typename?: "UploadServiceV2CollectionsStatusResponse";
    collectionId: string;
    fileCount: number;
    collectionType?: string | null;
    uploadExpiration?: string | null;
    finishFileUrl: string;
    uploadFiles?: Array<{
      __typename?: "UploadServiceV2FileStatusResponse";
      fileName?: string | null;
      fileSize?: number | null;
      collectionId?: string | null;
      contentType?: string | null;
      fileId?: string | null;
      externalFileId?: string | null;
      multipartUpload?: {
        __typename?: "UploadServiceV2MultipartUpload";
        key?: string | null;
        uploadId?: string | null;
        parts?: Array<{
          __typename?: "UploadServiceV2UploadPart";
          PartNumber?: number | null;
          uploadUrl?: string | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ApiCredentialsQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<ApiCredentialSearch>;
}>;

export type ApiCredentialsQuery = {
  __typename?: "Query";
  apiCredentials: {
    __typename?: "PagedApiCredentials";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "ApiCredentialsResponse";
      id: number;
      apiKey: string;
      customerPublicId: string;
      sharedSecret: string;
      description?: string | null;
      webhookSecret: string;
      isSandbox: boolean;
    }>;
  };
};

export type ListApiCredentialsQueryVariables = Exact<{ [key: string]: never }>;

export type ListApiCredentialsQuery = {
  __typename?: "Query";
  listApiCredentials: Array<{
    __typename?: "ApiCredentialsResponse";
    id: number;
    apiKey: string;
    customerPublicId: string;
    sharedSecret: string;
    description?: string | null;
    settings: any;
    webhookSecret: string;
    isSandbox: boolean;
  }>;
};

export type BulletinsQueryVariables = Exact<{ [key: string]: never }>;

export type BulletinsQuery = {
  __typename?: "Query";
  bulletins?: {
    __typename?: "BulletinResponse";
    paymentMethodMissing?: boolean | null;
    taxDocumentNotUploaded?: boolean | null;
    ordersLimit?: {
      __typename?: "OrderLimitBulletinResponse";
      isOrdersLimitActive?: boolean | null;
      configuredMaxOrdersWithin24h?: number | null;
      numOrdersReceivedUnderLimitLast24h?: number | null;
      configuredLimitQueueSize?: number | null;
      numOrdersInLimitQueue?: number | null;
      numRejectedOrdersQueueFullLast7Days?: number | null;
      isLimitQueueFull?: boolean | null;
    } | null;
  } | null;
};

export type AdminConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type AdminConfigurationQuery = {
  __typename?: "Query";
  adminConfiguration?: {
    __typename?: "AdminConfigResponse";
    avalaraTaxConfiguration?: any | null;
    dynamoDbConfiguration?: any | null;
    tasksConfiguration?: any | null;
    uosClientConfiguration?: any | null;
    pdfProcessingConfiguration?: any | null;
    shippingConfiguration?: any | null;
    dataSourceUrl?: string | null;
    nextChargeTime?: string | null;
    git?: any | null;
    holdingBinReleaseInHours?: number | null;
  } | null;
};

export type NextChargeTimeQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
}>;

export type NextChargeTimeQuery = { __typename?: "Query"; getNextChargeTime?: string | null };

export type AdminSearchCustomerCommunicationsQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<CustomerCommunicationSearch>;
}>;

export type AdminSearchCustomerCommunicationsQuery = {
  __typename?: "Query";
  adminSearchCustomerCommunications: {
    __typename?: "PagedCustomerCommunications";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "CustomerCommunicationResponse";
      id: number;
      email?: string | null;
      type: CustomerCommunicationType;
      createdAt: string;
      contents?: any | null;
      customer?: { __typename?: "CustomerResponse"; publicId: string } | null;
    }>;
  };
};

export type CustomerCommunicationQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type CustomerCommunicationQuery = {
  __typename?: "Query";
  customerCommunication: {
    __typename?: "CustomerCommunicationResponse";
    id: number;
    email?: string | null;
    type: CustomerCommunicationType;
    createdAt: string;
    contents?: any | null;
    customer?: { __typename?: "CustomerResponse"; publicId: string } | null;
  };
};

export type CustomerProductQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type CustomerProductQuery = {
  __typename?: "Query";
  customerProduct: {
    __typename?: "CustomerProductResponse";
    id: number;
    customerPublicId: string;
    customerSku: string;
    name?: string | null;
    description?: string | null;
    openapiProductId: number;
    createdAt: string;
  };
};

export type CustomerProductsQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<CustomerProductSearch>;
}>;

export type CustomerProductsQuery = {
  __typename?: "Query";
  customerProducts: {
    __typename?: "PagedCustomerProducts";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "CustomerProductResponse";
      id: number;
      customerPublicId: string;
      customerSku: string;
      name?: string | null;
      description?: string | null;
      openapiProductId: number;
      openapiProduct?: {
        __typename?: "OpenapiProductResponse";
        openapiSku: string;
        productPricing?: Array<{
          __typename?: "OpenapiProductPricing";
          currency: SupportedCurrency;
          basePrice: number;
          perPageCost: number;
        }> | null;
      } | null;
    }>;
  };
};

export type CustomerProductsSuperAdminQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<CustomerProductSearch>;
}>;

export type CustomerProductsSuperAdminQuery = {
  __typename?: "Query";
  customerProducts: {
    __typename?: "PagedCustomerProducts";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "CustomerProductResponse";
      id: number;
      customerPublicId: string;
      customerSku: string;
      name?: string | null;
      description?: string | null;
      openapiProductId: number;
      customer?: { __typename?: "CustomerResponse"; publicId: string; organizationName?: string | null } | null;
      openapiProduct?: {
        __typename?: "OpenapiProductResponse";
        openapiSku: string;
        productPricing?: Array<{
          __typename?: "OpenapiProductPricing";
          currency: SupportedCurrency;
          basePrice: number;
          perPageCost: number;
        }> | null;
      } | null;
    }>;
  };
};

export type ListCustomerProductsQueryVariables = Exact<{ [key: string]: never }>;

export type ListCustomerProductsQuery = {
  __typename?: "Query";
  listCustomerProducts: Array<{
    __typename?: "CustomerProductResponse";
    id: number;
    customerPublicId: string;
    customerSku: string;
    name?: string | null;
    description?: string | null;
    openapiProductId: number;
    openapiProduct?: { __typename?: "OpenapiProductResponse"; openapiSku: string } | null;
  }>;
};

export type AdminListCustomersQueryVariables = Exact<{
  input?: InputMaybe<Scalars["String"]>;
}>;

export type AdminListCustomersQuery = {
  __typename?: "Query";
  adminListCustomers?: Array<{
    __typename?: "CustomerResponse";
    id: number;
    publicId: string;
    email?: string | null;
    createdAt: string;
  }> | null;
};

export type AdminSearchCustomersQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<CustomerSearch>;
}>;

export type AdminSearchCustomersQuery = {
  __typename?: "Query";
  adminSearchCustomers: {
    __typename?: "PagedCustomers";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "CustomerResponse";
      id: number;
      publicId: string;
      email?: string | null;
      pdfProcessingApiaccount?: string | null;
      createdAt: string;
    }>;
  };
};

export type AdminSearchCustomersForFilterQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<CustomerSearch>;
}>;

export type AdminSearchCustomersForFilterQuery = {
  __typename?: "Query";
  adminSearchCustomers: {
    __typename?: "PagedCustomers";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{ __typename?: "CustomerResponse"; id: number; publicId: string; organizationName?: string | null }>;
  };
};

export type BillingCustomerQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
}>;

export type BillingCustomerQuery = {
  __typename?: "Query";
  customer: {
    __typename?: "CustomerResponse";
    id: number;
    publicId: string;
    chargeTax: boolean;
    taxDocuments?: Array<{
      __typename?: "UploadedFileResponse";
      id: number;
      collectionId: string;
      status: UploadedFileStatus;
      fileName: string;
      contentType: string;
      url?: string | null;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
  };
};

export type CustomerQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
}>;

export type CustomerQuery = {
  __typename?: "Query";
  customer: {
    __typename?: "CustomerResponse";
    id: number;
    publicId: string;
    pdfProcessingApiaccount?: string | null;
    email?: string | null;
    emailUpdates: boolean;
    secretKey?: string | null;
    chargeTax: boolean;
    createdAt: string;
    settings?: {
      __typename?: "CustomerSettings";
      shipping?: CustomerSettingsShipping | null;
      payments?: CustomerSettingsPayments | null;
      pricing?: CustomerSettingsPricing | null;
      allowPrintAssetCreation: boolean;
      allowCreateOrderFromPrintAsset: boolean;
      allowInstantPayment: boolean;
      allowMultipleCurrencies: boolean;
      vaultCustomerId?: string | null;
      ordersLimit?: {
        __typename?: "CustomerSettingsOrdersLimitResponse";
        limitQueueSize: number;
        maxOrders: number;
      } | null;
    } | null;
    dashboardUsers?: Array<{
      __typename?: "DashboardUserResponse";
      id: number;
      username?: string | null;
      sub?: string | null;
      email?: string | null;
      disabled?: boolean | null;
      role?: DashboardUserRole | null;
      createdAt: string;
    } | null> | null;
    taxDocuments?: Array<{
      __typename?: "UploadedFileResponse";
      id: number;
      collectionId: string;
      status: UploadedFileStatus;
      fileName: string;
      contentType: string;
      url?: string | null;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
  };
};

export type CustomerAdminRolesQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
}>;

export type CustomerAdminRolesQuery = {
  __typename?: "Query";
  customer: {
    __typename?: "CustomerResponse";
    publicId: string;
    dashboardUsers?: Array<{
      __typename?: "DashboardUserResponse";
      id: number;
      role?: DashboardUserRole | null;
    } | null> | null;
  };
};

export type PaymentOrganizationQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
}>;

export type PaymentOrganizationQuery = {
  __typename?: "Query";
  customer: { __typename?: "CustomerResponse"; publicId: string; organizationName?: string | null };
};

export type DashboardUserQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type DashboardUserQuery = {
  __typename?: "Query";
  dashboardUser: {
    __typename?: "DashboardUserResponse";
    id: number;
    username?: string | null;
    sub?: string | null;
    email?: string | null;
    disabled?: boolean | null;
    customerPublicId?: string | null;
    role?: DashboardUserRole | null;
    firstName?: string | null;
    lastName?: string | null;
    createdAt: string;
  };
};

export type DashboardUserCurrentQueryVariables = Exact<{ [key: string]: never }>;

export type DashboardUserCurrentQuery = {
  __typename?: "Query";
  dashboardUserCurrent: {
    __typename?: "DashboardUserResponse";
    id: number;
    username?: string | null;
    sub?: string | null;
    email?: string | null;
    disabled?: boolean | null;
    customerPublicId?: string | null;
    role?: DashboardUserRole | null;
    firstName?: string | null;
    lastName?: string | null;
    createdAt: string;
    settings?: any | null;
    customer?: {
      __typename?: "CustomerResponse";
      isOnboardingComplete?: boolean | null;
      organizationName?: string | null;
      organization: {
        __typename?: "OrganizationInformation";
        website?: string | null;
        size?: string | null;
        country?: string | null;
      };
      settings?: {
        __typename?: "CustomerSettings";
        ordersLimit?: {
          __typename?: "CustomerSettingsOrdersLimitResponse";
          maxOrders: number;
          limitQueueSize: number;
        } | null;
      } | null;
    } | null;
  };
};

export type DashboardUsersQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<DashboardUserSearch>;
}>;

export type DashboardUsersQuery = {
  __typename?: "Query";
  dashboardUsers: {
    __typename?: "PagedDashboardUsers";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "DashboardUserResponse";
      id: number;
      username?: string | null;
      sub?: string | null;
      email?: string | null;
      disabled?: boolean | null;
      customerPublicId?: string | null;
      role?: DashboardUserRole | null;
      firstName?: string | null;
      lastName?: string | null;
      createdAt: string;
      customer?: { __typename?: "CustomerResponse"; publicId: string; organizationName?: string | null } | null;
    }>;
  };
};

export type DailyMetricsQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
  numberOfDays: Scalars["Int"];
}>;

export type DailyMetricsQuery = {
  __typename?: "Query";
  dailyMetrics?: {
    __typename?: "DailyOrdersMetricsResponse";
    customerPublicId: string;
    numberOfDays: number;
    days: Array<{
      __typename?: "SingleDayMetricsResponse";
      createdDay: string;
      sumOrderTotals: number;
      numCreatedOrders: number;
    }>;
  } | null;
};

export type DailyPaymentMetricsQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
  numberOfDays: Scalars["Int"];
}>;

export type DailyPaymentMetricsQuery = {
  __typename?: "Query";
  dailyPaymentMetrics?: {
    __typename?: "PaymentsMetricsResponse";
    customerPublicId: string;
    numberOfDays: number;
    days: Array<{
      __typename?: "SinglePaymentMetricsResponse";
      createdDay: string;
      sumSaleTotals: number;
      sumRefundTotals: number;
    }>;
  } | null;
};

export type OrdersByPublicStatusMetricsQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
  numberOfDays: Scalars["Int"];
}>;

export type OrdersByPublicStatusMetricsQuery = {
  __typename?: "Query";
  ordersByPublicStatusMetrics?: {
    __typename?: "OrdersByPublicStatusMetricsResponse";
    customerPublicId: string;
    numberOfDays: number;
    ordersByPublicStatus: Array<{
      __typename?: "SingleOrdersByPublicStatusMetricResponse";
      publicStatus: PublicOrderStatus;
      numOrders: number;
    }>;
  } | null;
};

export type OrdersChartQueryVariables = Exact<{
  isSandbox: Scalars["Boolean"];
  timezone: Scalars["String"];
  year: Scalars["Int"];
}>;

export type OrdersChartQuery = {
  __typename?: "Query";
  ordersChart?: {
    __typename?: "OrdersChartResponse";
    availableYears: Array<number>;
    dataPoints: Array<{
      __typename?: "MonthlyOrdersByStatusDataPoint";
      month: string;
      statusCounts: Array<{ __typename?: "OrderStatusCount"; status: PublicOrderStatus; count: number }>;
    }>;
  } | null;
};

export type PaymentsChartQueryVariables = Exact<{
  isSandbox: Scalars["Boolean"];
  timezone: Scalars["String"];
  year: Scalars["Int"];
}>;

export type PaymentsChartQuery = {
  __typename?: "Query";
  paymentsChart?: {
    __typename?: "PaymentsChartResponse";
    availableYears: Array<number>;
    nextChargeDate?: string | null;
    dataPoints: Array<{
      __typename?: "MonthlyPaymentDataPoint";
      month: string;
      netPaymentAmount: number;
      currency: SupportedCurrency;
    }>;
  } | null;
};

export type ListOpenApiProductsQueryVariables = Exact<{
  hideAlreadyAssociatedProducts?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ListOpenApiProductsQuery = {
  __typename?: "Query";
  listOpenApiProducts: Array<{
    __typename?: "OpenapiProductResponse";
    id: number;
    name: string;
    openapiSku: string;
    skuAttributes?: any | null;
    productPricing?: Array<{
      __typename?: "OpenapiProductPricing";
      currency: SupportedCurrency;
      basePrice: number;
      perPageCost: number;
    }> | null;
    productSpecification: { __typename?: "OpenapiProductSpecification"; specification?: any | null };
  }>;
};

export type OpenApiProductQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type OpenApiProductQuery = {
  __typename?: "Query";
  openapiProduct: {
    __typename?: "OpenapiProductResponse";
    id: number;
    uosSku: string;
    openapiSku: string;
    uosMediaOption?: string | null;
    uosOrientation?: string | null;
    name: string;
    description?: string | null;
    skuAttributes?: any | null;
    enabled: boolean;
    productPricing?: Array<{
      __typename?: "OpenapiProductPricing";
      currency: SupportedCurrency;
      basePrice: number;
      perPageCost: number;
    }> | null;
    productSpecification: { __typename?: "OpenapiProductSpecification"; specification?: any | null };
  };
};

export type OpenApiProductWithPricingQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type OpenApiProductWithPricingQuery = {
  __typename?: "Query";
  openapiProduct: {
    __typename?: "OpenapiProductResponse";
    productPricing?: Array<{
      __typename?: "OpenapiProductPricing";
      currency: SupportedCurrency;
      basePrice: number;
      perPageCost: number;
    }> | null;
    productSpecification: { __typename?: "OpenapiProductSpecification"; specification?: any | null };
  };
};

export type OpenApiProductsQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<OpenapiProductSearch>;
}>;

export type OpenApiProductsQuery = {
  __typename?: "Query";
  openapiProducts: {
    __typename?: "PagedOpenApiProducts";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "OpenapiProductResponse";
      id: number;
      uosSku: string;
      openapiSku: string;
      uosMediaOption?: string | null;
      uosOrientation?: string | null;
      name: string;
      description?: string | null;
      skuAttributes?: any | null;
    }>;
  };
};

export type CalculateRefundByAmountQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByAmountInput;
}>;

export type CalculateRefundByAmountQuery = {
  __typename?: "Query";
  calculateRefundByAmount: {
    __typename?: "RefundCalculationResponse";
    refundSubtotal: number;
    refundTax: number;
    totalRefund: number;
    lineItems: Array<{
      __typename?: "RefundLineItemResponse";
      id: number;
      quantity: number;
      unitPrice: number;
      refundAmount: number;
      refundTax: number;
    }>;
  };
};

export type CalculateRefundByPercentageQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByPercentageInput;
}>;

export type CalculateRefundByPercentageQuery = {
  __typename?: "Query";
  calculateRefundByPercentage: {
    __typename?: "RefundCalculationResponse";
    refundSubtotal: number;
    refundTax: number;
    totalRefund: number;
    lineItems: Array<{
      __typename?: "RefundLineItemResponse";
      id: number;
      quantity: number;
      unitPrice: number;
      refundAmount: number;
      refundTax: number;
    }>;
  };
};

export type CalculateRefundByQuantityQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
  input: BraintreeRefundByQuantityInput;
}>;

export type CalculateRefundByQuantityQuery = {
  __typename?: "Query";
  calculateRefundByQuantity: {
    __typename?: "RefundCalculationResponse";
    refundSubtotal: number;
    refundTax: number;
    totalRefund: number;
    lineItems: Array<{
      __typename?: "RefundLineItemResponse";
      id: number;
      quantity: number;
      unitPrice: number;
      refundAmount: number;
      refundTax: number;
    }>;
  };
};

export type ListOrdersForPaymentQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
}>;

export type ListOrdersForPaymentQuery = {
  __typename?: "Query";
  listOrdersForPayment?: Array<{
    __typename?: "OrderResponse";
    customerOrderId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    pricing?: {
      __typename?: "OrderPricing";
      orderTotal?: number | null;
      itemsTotal?: number | null;
      taxesTotal?: number | null;
      shippingTotal?: number | null;
      currency?: SupportedCurrency | null;
    } | null;
  }> | null;
};

export type OrderQueryVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
  isSandbox: Scalars["Boolean"];
}>;

export type OrderQuery = {
  __typename?: "Query";
  orderByIdentifier: {
    __typename?: "OrderResponse";
    id?: number | null;
    reprintParentCustomerPublicId?: string | null;
    reprintParentCustomerOrderId?: string | null;
    customerOrderId?: string | null;
    paymentStatus?: PaymentStatus | null;
    publicOrderStatus?: PublicOrderStatus | null;
    status?: OrderStatus | null;
    canReprint?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    submittedAt?: string | null;
    paymentMode?: PaymentMode | null;
    currency?: SupportedCurrency | null;
    webhookUri?: string | null;
    lastStatusMessage?: string | null;
    validationResult?: any | null;
    additionalPayload?: string | null;
    canDoFullRefund?: boolean | null;
    canRefund?: boolean | null;
    remainingPossibleRefund?: number | null;
    isSandbox: boolean;
    customer?: { __typename?: "CustomerResponse"; id: number; publicId: string; email?: string | null } | null;
    destination?: {
      __typename?: "DestinationResponse";
      id: number;
      shippingMethodCode?: string | null;
      shippingDetails?: any | null;
      address?: {
        __typename?: "AddressResponse";
        id: number;
        createdAt?: string | null;
        updatedAt?: string | null;
        name?: string | null;
        company?: string | null;
        address1?: string | null;
        address2?: string | null;
        address3?: string | null;
        postalCode?: string | null;
        city?: string | null;
        regionIso?: string | null;
        countryIso?: string | null;
        phone?: string | null;
        email?: string | null;
      } | null;
    } | null;
    orderEvents?: Array<{
      __typename?: "OrderEventResponse";
      id?: number | null;
      customerOrderId?: string | null;
      eventTime?: string | null;
      eventType?: string | null;
      shortDesc?: string | null;
      data?: any | null;
    }> | null;
    callbacks?: Array<{
      __typename?: "CallbackResponse";
      urlEndpoint?: string | null;
      attemptCount?: number | null;
      webhookId?: string | null;
      webhookStatus?: string | null;
      timeline?: any | null;
      body?: any | null;
    }> | null;
    orderItems?: Array<{
      __typename?: "OrderItemResponse";
      id: number;
      orderItemStatus?: OrderItemStatus | null;
      pagecount?: number | null;
      coverUri?: string | null;
      gutsUri?: string | null;
      imageUri?: string | null;
      validationResult?: any | null;
      pricingAlgorithm?: string | null;
      pricingDetails?: any | null;
      quantity?: number | null;
      unitPrice?: number | null;
      openapiProduct?: {
        __typename?: "OpenapiProductResponse";
        id: number;
        uosSku: string;
        openapiSku: string;
        uosMediaOption?: string | null;
        uosOrientation?: string | null;
        name: string;
        description?: string | null;
        productSpecification: {
          __typename?: "OpenapiProductSpecification";
          id: number;
          name: string;
          type: string;
          version: number;
          md5Hash?: string | null;
          processingTemplate: string;
          processingSettings: any;
        };
      } | null;
      customerProduct?: {
        __typename?: "CustomerProductResponse";
        id: number;
        customerPublicId: string;
        customerSku: string;
        name?: string | null;
        description?: string | null;
        openapiProductId: number;
      } | null;
      printAsset?: {
        __typename?: "PrintAssetResponse";
        id: number;
        printAssetUploadId?: string | null;
        status?: PrintAssetStatus | null;
        previews?: any | null;
        preflightOutputFiles?: any | null;
        customer?: { __typename?: "CustomerResponse"; id: number; publicId: string; email?: string | null } | null;
      } | null;
    }> | null;
    pricing?: {
      __typename?: "OrderPricing";
      currency?: SupportedCurrency | null;
      itemsTotal?: number | null;
      orderTotal?: number | null;
      shippingTotal?: number | null;
      taxesTotal?: number | null;
    } | null;
    shipments?: Array<{
      __typename?: "ShipmentResponse";
      id: number;
      status?: string | null;
      isFinalShipment?: boolean | null;
      shippedDate?: string | null;
      shippingMethodCode?: string | null;
      trackingNumber?: string | null;
      masterTrackingNumber?: string | null;
      secondaryTrackingNumber?: string | null;
      rawShipmentData?: any | null;
      destination?: {
        __typename?: "DestinationResponse";
        id: number;
        shippingMethodCode?: string | null;
        shippingDetails?: any | null;
        address?: {
          __typename?: "AddressResponse";
          id: number;
          createdAt?: string | null;
          updatedAt?: string | null;
          name?: string | null;
          company?: string | null;
          address1?: string | null;
          address2?: string | null;
          address3?: string | null;
          postalCode?: string | null;
          city?: string | null;
          regionIso?: string | null;
          countryIso?: string | null;
          phone?: string | null;
          email?: string | null;
        } | null;
      } | null;
      orderItems?: Array<{
        __typename?: "OrderItemResponse";
        id: number;
        quantity?: number | null;
        pagecount?: number | null;
        unitPrice?: number | null;
        coverUri?: string | null;
        gutsUri?: string | null;
        imageUri?: string | null;
        orderItemStatus?: OrderItemStatus | null;
        validationResult?: any | null;
        customerProduct?: {
          __typename?: "CustomerProductResponse";
          id: number;
          customerSku: string;
          name?: string | null;
          description?: string | null;
        } | null;
        openapiProduct?: { __typename?: "OpenapiProductResponse"; id: number; openapiSku: string; name: string } | null;
        printAsset?: {
          __typename?: "PrintAssetResponse";
          id: number;
          status?: PrintAssetStatus | null;
          preflightOutputFiles?: any | null;
        } | null;
      }> | null;
    }> | null;
    salePayment?: { __typename?: "PaymentResponse"; id?: number | null } | null;
    refunds?: Array<{
      __typename?: "PaymentResponse";
      id?: number | null;
      saleParentPaymentId?: number | null;
      customerPublicId?: string | null;
      braintreeTransactionId?: string | null;
      amount?: number | null;
      currency?: SupportedCurrency | null;
      transactionType?: TransactionType | null;
      createdAt?: string | null;
    }> | null;
  };
};

export type OrderCallbacksQueryVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
  isSandbox: Scalars["Boolean"];
}>;

export type OrderCallbacksQuery = {
  __typename?: "Query";
  orderByIdentifier: {
    __typename?: "OrderResponse";
    callbacks?: Array<{
      __typename?: "CallbackResponse";
      body?: any | null;
      webhookStatus?: string | null;
      urlEndpoint?: string | null;
      attemptCount?: number | null;
      webhookId?: string | null;
      timeline?: any | null;
    }> | null;
  };
};

export type OrderDetailsQueryVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
  isSandbox: Scalars["Boolean"];
}>;

export type OrderDetailsQuery = {
  __typename?: "Query";
  orderByIdentifier: {
    __typename?: "OrderResponse";
    paymentStatus?: PaymentStatus | null;
    createdAt?: string | null;
    submittedAt?: string | null;
    lastStatusMessage?: string | null;
    reprintParentCustomerOrderId?: string | null;
    reprintParentCustomerPublicId?: string | null;
    customer?: { __typename?: "CustomerResponse"; organizationName?: string | null } | null;
    pricing?: {
      __typename?: "OrderPricing";
      currency?: SupportedCurrency | null;
      itemsTotal?: number | null;
      shippingTotal?: number | null;
      taxesTotal?: number | null;
      orderTotal?: number | null;
    } | null;
    salePayment?: {
      __typename?: "PaymentResponse";
      id?: number | null;
      createdAt?: string | null;
      paymentMethodLabel?: string | null;
    } | null;
    refunds?: Array<{
      __typename?: "PaymentResponse";
      id?: number | null;
      amount?: number | null;
      createdAt?: string | null;
      refundDetails?: {
        __typename?: "RefundDetails";
        strategy: BraintreeRefundStrategy;
        itemsRefundAmount: number;
        shippingRefundAmount: number;
        taxesRefundAmount: number;
        reason?: RefundReason | null;
        reasonNote?: string | null;
      } | null;
    }> | null;
  };
};

export type OrderEventsQueryVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
  isSandbox: Scalars["Boolean"];
  isSuperAdmin: Scalars["Boolean"];
}>;

export type OrderEventsQuery = {
  __typename?: "Query";
  orderByIdentifier: {
    __typename?: "OrderResponse";
    orderEvents?: Array<{
      __typename?: "OrderEventResponse";
      eventTime?: string | null;
      eventType?: string | null;
      shortDesc?: string | null;
      data?: any | null;
      webhookSourceName?: string | null;
    }> | null;
  };
};

export type OrderItemsQueryVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
  isSandbox: Scalars["Boolean"];
}>;

export type OrderItemsQuery = {
  __typename?: "Query";
  orderByIdentifier: {
    __typename?: "OrderResponse";
    currency?: SupportedCurrency | null;
    orderItems?: Array<{
      __typename?: "OrderItemResponse";
      id: number;
      orderItemStatus?: OrderItemStatus | null;
      pagecount?: number | null;
      imageUri?: string | null;
      quantity?: number | null;
      unitPrice?: number | null;
      validationResult?: any | null;
      openapiProduct?: { __typename?: "OpenapiProductResponse"; openapiSku: string } | null;
      customerProduct?: {
        __typename?: "CustomerProductResponse";
        name?: string | null;
        description?: string | null;
      } | null;
      printAsset?: {
        __typename?: "PrintAssetResponse";
        status?: PrintAssetStatus | null;
        preflightOutputFiles?: any | null;
      } | null;
    }> | null;
  };
};

export type OrderMinimalQueryVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
  isSandbox: Scalars["Boolean"];
}>;

export type OrderMinimalQuery = {
  __typename?: "Query";
  orderByIdentifier: {
    __typename?: "OrderResponse";
    customerOrderId?: string | null;
    orderPublicId?: string | null;
    uosOrderId?: string | null;
    paymentStatus?: PaymentStatus | null;
    publicOrderStatus?: PublicOrderStatus | null;
    status?: OrderStatus | null;
    canRefund?: boolean | null;
    canReprint?: boolean | null;
    customer?: { __typename?: "CustomerResponse"; publicId: string } | null;
  };
};

export type OrderRefundReprintInfoQueryVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
  isSandbox: Scalars["Boolean"];
}>;

export type OrderRefundReprintInfoQuery = {
  __typename?: "Query";
  orderByIdentifier: {
    __typename?: "OrderResponse";
    customerOrderId?: string | null;
    currency?: SupportedCurrency | null;
    pricing?: {
      __typename?: "OrderPricing";
      itemsTotal?: number | null;
      shippingTotal?: number | null;
      taxesTotal?: number | null;
      orderTotal?: number | null;
    } | null;
    customer?: { __typename?: "CustomerResponse"; publicId: string } | null;
    destination?: { __typename?: "DestinationResponse"; shippingMethodCode?: string | null } | null;
    orderItems?: Array<{
      __typename?: "OrderItemResponse";
      id: number;
      quantity?: number | null;
      openapiProduct?: { __typename?: "OpenapiProductResponse"; name: string } | null;
      customerProduct?: { __typename?: "CustomerProductResponse"; name?: string | null } | null;
    }> | null;
  };
};

export type OrderShipmentsQueryVariables = Exact<{
  orderIdentifier: OrderIdentifierInput;
  isSandbox: Scalars["Boolean"];
}>;

export type OrderShipmentsQuery = {
  __typename?: "Query";
  orderByIdentifier: {
    __typename?: "OrderResponse";
    currency?: SupportedCurrency | null;
    destination?: {
      __typename?: "DestinationResponse";
      id: number;
      shippingDetails?: any | null;
      address?: {
        __typename?: "AddressResponse";
        name?: string | null;
        address1?: string | null;
        address2?: string | null;
        address3?: string | null;
        city?: string | null;
        countryIso?: string | null;
        postalCode?: string | null;
        regionIso?: string | null;
        email?: string | null;
        phone?: string | null;
      } | null;
    } | null;
    shipments?: Array<{
      __typename?: "ShipmentResponse";
      id: number;
      shippingMethodCode?: string | null;
      trackingNumber?: string | null;
      secondaryTrackingNumber?: string | null;
      masterTrackingNumber?: string | null;
      destination?: {
        __typename?: "DestinationResponse";
        shippingDetails?: any | null;
        address?: {
          __typename?: "AddressResponse";
          name?: string | null;
          address1?: string | null;
          address2?: string | null;
          address3?: string | null;
          city?: string | null;
          countryIso?: string | null;
          postalCode?: string | null;
          regionIso?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
      } | null;
      orderItems?: Array<{
        __typename?: "OrderItemResponse";
        id: number;
        orderItemStatus?: OrderItemStatus | null;
        pagecount?: number | null;
        imageUri?: string | null;
        quantity?: number | null;
        unitPrice?: number | null;
        validationResult?: any | null;
        openapiProduct?: { __typename?: "OpenapiProductResponse"; openapiSku: string } | null;
        customerProduct?: {
          __typename?: "CustomerProductResponse";
          name?: string | null;
          description?: string | null;
        } | null;
        printAsset?: {
          __typename?: "PrintAssetResponse";
          status?: PrintAssetStatus | null;
          preflightOutputFiles?: any | null;
        } | null;
      }> | null;
    }> | null;
  };
};

export type OrdersQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<OrderSearch>;
}>;

export type OrdersQuery = {
  __typename?: "Query";
  orders: {
    __typename?: "PagedOrders";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "OrderResponse";
      customerOrderId?: string | null;
      orderPublicId?: string | null;
      publicOrderStatus?: PublicOrderStatus | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      submittedAt?: string | null;
      paymentStatus?: PaymentStatus | null;
      currency?: SupportedCurrency | null;
      lastStatusMessage?: string | null;
      isSandbox: boolean;
      customer?: { __typename?: "CustomerResponse"; publicId: string; organizationName?: string | null } | null;
      pricing?: {
        __typename?: "OrderPricing";
        currency?: SupportedCurrency | null;
        itemsTotal?: number | null;
        orderTotal?: number | null;
        shippingTotal?: number | null;
        taxesTotal?: number | null;
      } | null;
    }>;
  };
};

export type ListPaymentMethodsQueryVariables = Exact<{
  customerPublicId: Scalars["String"];
}>;

export type ListPaymentMethodsQuery = {
  __typename?: "Query";
  listPaymentMethods: Array<{
    __typename?: "BraintreePaymentMethodResponse";
    cardholderName?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    countryIso2?: string | null;
    countryName?: string | null;
    name?: string | null;
    imageUrl?: string | null;
    customerId?: string | null;
    message?: string | null;
    token?: string | null;
    isDefault?: boolean | null;
    last4Digits?: string | null;
    maskedCCNumber?: string | null;
    expiryDate?: string | null;
  }>;
};

export type PaymentQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]>;
}>;

export type PaymentQuery = {
  __typename?: "Query";
  payment: {
    __typename?: "PaymentResponse";
    id?: number | null;
    saleParentPaymentId?: number | null;
    customerPublicId?: string | null;
    braintreeTransactionId?: string | null;
    amount?: number | null;
    currency?: SupportedCurrency | null;
    transactionType?: TransactionType | null;
    notes?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    paymentInfo?: any | null;
    paidOrders?: Array<{
      __typename?: "OrderResponse";
      customerOrderId?: string | null;
      orderPublicId?: string | null;
      publicOrderStatus?: PublicOrderStatus | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      submittedAt?: string | null;
      paymentStatus?: PaymentStatus | null;
      currency?: SupportedCurrency | null;
      lastStatusMessage?: string | null;
      isSandbox: boolean;
      customer?: { __typename?: "CustomerResponse"; publicId: string; organizationName?: string | null } | null;
      pricing?: {
        __typename?: "OrderPricing";
        currency?: SupportedCurrency | null;
        itemsTotal?: number | null;
        orderTotal?: number | null;
        shippingTotal?: number | null;
        taxesTotal?: number | null;
      } | null;
    }> | null;
    refundedOrder?: {
      __typename?: "OrderResponse";
      customerOrderId?: string | null;
      currency?: SupportedCurrency | null;
      canDoFullRefund?: boolean | null;
      remainingPossibleRefund?: number | null;
      status?: OrderStatus | null;
      publicOrderStatus?: PublicOrderStatus | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      submittedAt?: string | null;
      lastStatusMessage?: string | null;
      pricing?: {
        __typename?: "OrderPricing";
        currency?: SupportedCurrency | null;
        itemsTotal?: number | null;
        orderTotal?: number | null;
        shippingTotal?: number | null;
        taxesTotal?: number | null;
      } | null;
      customer?: { __typename?: "CustomerResponse"; publicId: string } | null;
    } | null;
    refundDetails?: {
      __typename?: "RefundDetails";
      refundedBy?: {
        __typename?: "UserActorResponse";
        firstName?: string | null;
        lastName?: string | null;
        email: string;
      } | null;
    } | null;
  };
};

export type PaymentByTransactionIdQueryVariables = Exact<{
  braintreeTransactionId?: InputMaybe<Scalars["String"]>;
}>;

export type PaymentByTransactionIdQuery = {
  __typename?: "Query";
  paymentByTransactionId: {
    __typename?: "PaymentResponse";
    id?: number | null;
    customerPublicId?: string | null;
    braintreeTransactionId?: string | null;
    amount?: number | null;
    currency?: SupportedCurrency | null;
    paymentInfo?: any | null;
    paidOrders?: Array<{
      __typename?: "OrderResponse";
      customerOrderId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      pricing?: {
        __typename?: "OrderPricing";
        currency?: SupportedCurrency | null;
        itemsTotal?: number | null;
        orderTotal?: number | null;
        shippingTotal?: number | null;
        taxesTotal?: number | null;
      } | null;
    }> | null;
  };
};

export type PaymentsQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<PaymentSearch>;
}>;

export type PaymentsQuery = {
  __typename?: "Query";
  payments: {
    __typename?: "PagedPaymentSearchResponse";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "PaymentResponse";
      id?: number | null;
      saleParentPaymentId?: number | null;
      customerPublicId?: string | null;
      braintreeTransactionId?: string | null;
      amount?: number | null;
      currency?: SupportedCurrency | null;
      transactionType?: TransactionType | null;
      createdAt?: string | null;
    }>;
  };
};

export type PrintAssetQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type PrintAssetQuery = {
  __typename?: "Query";
  printAsset: {
    __typename?: "PrintAssetResponse";
    id: number;
    printAssetUploadId?: string | null;
    status?: PrintAssetStatus | null;
    previews?: any | null;
    preflightOutputFiles?: any | null;
    report?: any | null;
    customer?: {
      __typename?: "CustomerResponse";
      id: number;
      publicId: string;
      pdfProcessingApiaccount?: string | null;
      email?: string | null;
    } | null;
  };
};

export type PrintAssetsQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<PrintAssetSearch>;
}>;

export type PrintAssetsQuery = {
  __typename?: "Query";
  printAssets: {
    __typename?: "PagedPrintAssets";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "PrintAssetResponse";
      id: number;
      printAssetUploadId?: string | null;
      status?: PrintAssetStatus | null;
      updatedAt?: string | null;
      customer?: { __typename?: "CustomerResponse"; publicId: string; organizationName?: string | null } | null;
    }>;
  };
};

export type UploadFilesByPollCollectionQueryVariables = Exact<{
  collectionId: Scalars["String"];
  customerPublicId: Scalars["String"];
}>;

export type UploadFilesByPollCollectionQuery = {
  __typename?: "Query";
  uploadFilesPollByCollection?: Array<{
    __typename?: "UploadedFileResponse";
    id: number;
    collectionId: string;
    status: UploadedFileStatus;
    fileName: string;
    contentType: string;
    url?: string | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    isTaxDocument?: boolean | null;
    customer: { __typename?: "CustomerResponse"; id: number; publicId: string };
  } | null> | null;
};

export type UploadedFileQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type UploadedFileQuery = {
  __typename?: "Query";
  uploadedFile: {
    __typename?: "UploadedFileResponse";
    id: number;
    collectionId: string;
    status: UploadedFileStatus;
    fileName: string;
    contentType: string;
    url?: string | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    customer: { __typename?: "CustomerResponse"; id: number; publicId: string };
  };
};

export type UploadedFilesQueryVariables = Exact<{
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  search?: InputMaybe<UploadedFileSearch>;
}>;

export type UploadedFilesQuery = {
  __typename?: "Query";
  uploadedFiles: {
    __typename?: "PagedUploadedFiles";
    totalCount?: number | null;
    offset?: number | null;
    nextOffset?: number | null;
    prevOffset?: number | null;
    data: Array<{
      __typename?: "UploadedFileResponse";
      id: number;
      collectionId: string;
      status: UploadedFileStatus;
      fileName: string;
      contentType: string;
      url?: string | null;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
      isTaxDocument?: boolean | null;
      customer: { __typename?: "CustomerResponse"; id: number; publicId: string; organizationName?: string | null };
    }>;
  };
};

export const OrderItemFieldsFragmentDoc = `
    fragment OrderItemFields on OrderItemResponse {
  id
  openapiProduct {
    openapiSku
  }
  customerProduct {
    name
    description
  }
  printAsset {
    status
    preflightOutputFiles
  }
  orderItemStatus
  pagecount
  imageUri
  quantity
  unitPrice
  validationResult
}
    `;
export const OrderRowFieldsFragmentDoc = `
    fragment OrderRowFields on OrderResponse {
  customer {
    publicId
    organizationName
  }
  customerOrderId
  orderPublicId
  publicOrderStatus
  createdAt
  updatedAt
  submittedAt
  paymentStatus
  pricing {
    currency
    itemsTotal
    orderTotal
    shippingTotal
    taxesTotal
  }
  currency
  lastStatusMessage
  isSandbox
}
    `;
export const CreateApiCredentialDocument = `
    mutation CreateApiCredential($input: ApiCredentialsInput) {
  apiCredentialsCreate(apiCredentialsInput: $input) {
    id
  }
}
    `;
export const useCreateApiCredentialMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreateApiCredentialMutation, TError, CreateApiCredentialMutationVariables, TContext>
) =>
  useMutation<CreateApiCredentialMutation, TError, CreateApiCredentialMutationVariables, TContext>(
    ["CreateApiCredential"],
    useRpiGraphqlRequest<CreateApiCredentialMutation, CreateApiCredentialMutationVariables>(
      CreateApiCredentialDocument
    ),
    options
  );
export const AdminRefundOrderDocument = `
    mutation AdminRefundOrder($input: BraintreeRefundInput, $customerPublicId: String!) {
  adminRefundOrder(
    braintreeRefundInput: $input
    customerPublicId: $customerPublicId
  ) {
    message
  }
}
    `;
export const useAdminRefundOrderMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<AdminRefundOrderMutation, TError, AdminRefundOrderMutationVariables, TContext>
) =>
  useMutation<AdminRefundOrderMutation, TError, AdminRefundOrderMutationVariables, TContext>(
    ["AdminRefundOrder"],
    useRpiGraphqlRequest<AdminRefundOrderMutation, AdminRefundOrderMutationVariables>(AdminRefundOrderDocument),
    options
  );
export const AdminRefundOrderByAmountDocument = `
    mutation AdminRefundOrderByAmount($customerPublicId: String!, $input: BraintreeRefundByAmountInput!) {
  adminRefundOrderByAmount(customerPublicId: $customerPublicId, input: $input) {
    message
  }
}
    `;
export const useAdminRefundOrderByAmountMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AdminRefundOrderByAmountMutation,
    TError,
    AdminRefundOrderByAmountMutationVariables,
    TContext
  >
) =>
  useMutation<AdminRefundOrderByAmountMutation, TError, AdminRefundOrderByAmountMutationVariables, TContext>(
    ["AdminRefundOrderByAmount"],
    useRpiGraphqlRequest<AdminRefundOrderByAmountMutation, AdminRefundOrderByAmountMutationVariables>(
      AdminRefundOrderByAmountDocument
    ),
    options
  );
export const AdminRefundOrderByPercentageDocument = `
    mutation AdminRefundOrderByPercentage($customerPublicId: String!, $input: BraintreeRefundByPercentageInput!) {
  adminRefundOrderByPercentage(customerPublicId: $customerPublicId, input: $input) {
    message
  }
}
    `;
export const useAdminRefundOrderByPercentageMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AdminRefundOrderByPercentageMutation,
    TError,
    AdminRefundOrderByPercentageMutationVariables,
    TContext
  >
) =>
  useMutation<AdminRefundOrderByPercentageMutation, TError, AdminRefundOrderByPercentageMutationVariables, TContext>(
    ["AdminRefundOrderByPercentage"],
    useRpiGraphqlRequest<AdminRefundOrderByPercentageMutation, AdminRefundOrderByPercentageMutationVariables>(
      AdminRefundOrderByPercentageDocument
    ),
    options
  );
export const AdminRefundOrderByQuantityDocument = `
    mutation AdminRefundOrderByQuantity($customerPublicId: String!, $input: BraintreeRefundByQuantityInput!) {
  adminRefundOrderByQuantity(customerPublicId: $customerPublicId, input: $input) {
    message
  }
}
    `;
export const useAdminRefundOrderByQuantityMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AdminRefundOrderByQuantityMutation,
    TError,
    AdminRefundOrderByQuantityMutationVariables,
    TContext
  >
) =>
  useMutation<AdminRefundOrderByQuantityMutation, TError, AdminRefundOrderByQuantityMutationVariables, TContext>(
    ["AdminRefundOrderByQuantity"],
    useRpiGraphqlRequest<AdminRefundOrderByQuantityMutation, AdminRefundOrderByQuantityMutationVariables>(
      AdminRefundOrderByQuantityDocument
    ),
    options
  );
export const CreateBraintreePaymentDocument = `
    mutation CreateBraintreePayment($input: BraintreeCheckoutInput) {
  braintreePaymentCreate(braintreeCheckoutInput: $input) {
    message
    braintreeTransactionId
  }
}
    `;
export const useCreateBraintreePaymentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateBraintreePaymentMutation,
    TError,
    CreateBraintreePaymentMutationVariables,
    TContext
  >
) =>
  useMutation<CreateBraintreePaymentMutation, TError, CreateBraintreePaymentMutationVariables, TContext>(
    ["CreateBraintreePayment"],
    useRpiGraphqlRequest<CreateBraintreePaymentMutation, CreateBraintreePaymentMutationVariables>(
      CreateBraintreePaymentDocument
    ),
    options
  );
export const CreateCustomerProductDocument = `
    mutation CreateCustomerProduct($input: CreateCustomerProductInput) {
  customerProductCreate(createCustomerProductInput: $input) {
    id
  }
}
    `;
export const useCreateCustomerProductMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreateCustomerProductMutation, TError, CreateCustomerProductMutationVariables, TContext>
) =>
  useMutation<CreateCustomerProductMutation, TError, CreateCustomerProductMutationVariables, TContext>(
    ["CreateCustomerProduct"],
    useRpiGraphqlRequest<CreateCustomerProductMutation, CreateCustomerProductMutationVariables>(
      CreateCustomerProductDocument
    ),
    options
  );
export const EditCustomerProductDocument = `
    mutation EditCustomerProduct($id: Int!, $input: EditCustomerProductInput) {
  customerProductEdit(id: $id, editCustomerProductInput: $input) {
    id
  }
}
    `;
export const useEditCustomerProductMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<EditCustomerProductMutation, TError, EditCustomerProductMutationVariables, TContext>
) =>
  useMutation<EditCustomerProductMutation, TError, EditCustomerProductMutationVariables, TContext>(
    ["EditCustomerProduct"],
    useRpiGraphqlRequest<EditCustomerProductMutation, EditCustomerProductMutationVariables>(
      EditCustomerProductDocument
    ),
    options
  );
export const AdminCreateCustomerDocument = `
    mutation AdminCreateCustomer($input: CustomerInput) {
  adminCreateCustomer(createCustomerInput: $input) {
    id
  }
}
    `;
export const useAdminCreateCustomerMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<AdminCreateCustomerMutation, TError, AdminCreateCustomerMutationVariables, TContext>
) =>
  useMutation<AdminCreateCustomerMutation, TError, AdminCreateCustomerMutationVariables, TContext>(
    ["AdminCreateCustomer"],
    useRpiGraphqlRequest<AdminCreateCustomerMutation, AdminCreateCustomerMutationVariables>(
      AdminCreateCustomerDocument
    ),
    options
  );
export const AdminEditCustomerDocument = `
    mutation AdminEditCustomer($input: EditCustomerInput) {
  adminEditCustomer(editCustomerInput: $input) {
    id
  }
}
    `;
export const useAdminEditCustomerMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<AdminEditCustomerMutation, TError, AdminEditCustomerMutationVariables, TContext>
) =>
  useMutation<AdminEditCustomerMutation, TError, AdminEditCustomerMutationVariables, TContext>(
    ["AdminEditCustomer"],
    useRpiGraphqlRequest<AdminEditCustomerMutation, AdminEditCustomerMutationVariables>(AdminEditCustomerDocument),
    options
  );
export const AdminEditCustomerLimitsDocument = `
    mutation AdminEditCustomerLimits($customerPublicId: String!, $input: CustomerSettingsOrdersLimit) {
  adminEditCustomerLimits(
    customerPublicId: $customerPublicId
    customerSettingsOrdersLimit: $input
  ) {
    id
  }
}
    `;
export const useAdminEditCustomerLimitsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AdminEditCustomerLimitsMutation,
    TError,
    AdminEditCustomerLimitsMutationVariables,
    TContext
  >
) =>
  useMutation<AdminEditCustomerLimitsMutation, TError, AdminEditCustomerLimitsMutationVariables, TContext>(
    ["AdminEditCustomerLimits"],
    useRpiGraphqlRequest<AdminEditCustomerLimitsMutation, AdminEditCustomerLimitsMutationVariables>(
      AdminEditCustomerLimitsDocument
    ),
    options
  );
export const AdminUpdateCustomerSecretAndSettingsDocument = `
    mutation AdminUpdateCustomerSecretAndSettings($customerPublicId: String!, $customerType: CustomerType!, $secretKey: String!) {
  adminUpdateCustomerSecretAndSettings(
    customerPublicId: $customerPublicId
    customerType: $customerType
    secretKey: $secretKey
  ) {
    publicId
    secretKey
    settings {
      payments
      pricing
    }
  }
}
    `;
export const useAdminUpdateCustomerSecretAndSettingsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AdminUpdateCustomerSecretAndSettingsMutation,
    TError,
    AdminUpdateCustomerSecretAndSettingsMutationVariables,
    TContext
  >
) =>
  useMutation<
    AdminUpdateCustomerSecretAndSettingsMutation,
    TError,
    AdminUpdateCustomerSecretAndSettingsMutationVariables,
    TContext
  >(
    ["AdminUpdateCustomerSecretAndSettings"],
    useRpiGraphqlRequest<
      AdminUpdateCustomerSecretAndSettingsMutation,
      AdminUpdateCustomerSecretAndSettingsMutationVariables
    >(AdminUpdateCustomerSecretAndSettingsDocument),
    options
  );
export const EditOrganizationInformationDocument = `
    mutation EditOrganizationInformation($input: EditOrganizationInformationInput!) {
  editOrganizationInformation(input: $input) {
    publicId
    organizationName
    organization {
      website
      size
      country
    }
  }
}
    `;
export const useEditOrganizationInformationMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditOrganizationInformationMutation,
    TError,
    EditOrganizationInformationMutationVariables,
    TContext
  >
) =>
  useMutation<EditOrganizationInformationMutation, TError, EditOrganizationInformationMutationVariables, TContext>(
    ["EditOrganizationInformation"],
    useRpiGraphqlRequest<EditOrganizationInformationMutation, EditOrganizationInformationMutationVariables>(
      EditOrganizationInformationDocument
    ),
    options
  );
export const OnboardCustomerDocument = `
    mutation OnboardCustomer($input: OnboardingInput!) {
  onboardCustomer(onboardingInput: $input) {
    isOnboardingComplete
  }
}
    `;
export const useOnboardCustomerMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<OnboardCustomerMutation, TError, OnboardCustomerMutationVariables, TContext>
) =>
  useMutation<OnboardCustomerMutation, TError, OnboardCustomerMutationVariables, TContext>(
    ["OnboardCustomer"],
    useRpiGraphqlRequest<OnboardCustomerMutation, OnboardCustomerMutationVariables>(OnboardCustomerDocument),
    options
  );
export const ChangeDashboardUserPasswordDocument = `
    mutation ChangeDashboardUserPassword($id: Int!, $input: ChangePasswordDashboardUserInput) {
  dashboardUserChangePassword(id: $id, changePasswordDashboardUserInput: $input) {
    id
  }
}
    `;
export const useChangeDashboardUserPasswordMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ChangeDashboardUserPasswordMutation,
    TError,
    ChangeDashboardUserPasswordMutationVariables,
    TContext
  >
) =>
  useMutation<ChangeDashboardUserPasswordMutation, TError, ChangeDashboardUserPasswordMutationVariables, TContext>(
    ["ChangeDashboardUserPassword"],
    useRpiGraphqlRequest<ChangeDashboardUserPasswordMutation, ChangeDashboardUserPasswordMutationVariables>(
      ChangeDashboardUserPasswordDocument
    ),
    options
  );
export const CreateDashboardUserDocument = `
    mutation CreateDashboardUser($input: DashboardUserInput) {
  dashboardUserCreate(createDashboardUserInput: $input) {
    id
  }
}
    `;
export const useCreateDashboardUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreateDashboardUserMutation, TError, CreateDashboardUserMutationVariables, TContext>
) =>
  useMutation<CreateDashboardUserMutation, TError, CreateDashboardUserMutationVariables, TContext>(
    ["CreateDashboardUser"],
    useRpiGraphqlRequest<CreateDashboardUserMutation, CreateDashboardUserMutationVariables>(
      CreateDashboardUserDocument
    ),
    options
  );
export const DeleteDashboardUserDocument = `
    mutation DeleteDashboardUser($id: Int!) {
  dashboardUserDelete(id: $id)
}
    `;
export const useDeleteDashboardUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<DeleteDashboardUserMutation, TError, DeleteDashboardUserMutationVariables, TContext>
) =>
  useMutation<DeleteDashboardUserMutation, TError, DeleteDashboardUserMutationVariables, TContext>(
    ["DeleteDashboardUser"],
    useRpiGraphqlRequest<DeleteDashboardUserMutation, DeleteDashboardUserMutationVariables>(
      DeleteDashboardUserDocument
    ),
    options
  );
export const EditDashboardUserDocument = `
    mutation EditDashboardUser($id: Int!, $input: EditDashboardUserInput) {
  dashboardUserEdit(id: $id, editDashboardUserInput: $input) {
    id
  }
}
    `;
export const useEditDashboardUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<EditDashboardUserMutation, TError, EditDashboardUserMutationVariables, TContext>
) =>
  useMutation<EditDashboardUserMutation, TError, EditDashboardUserMutationVariables, TContext>(
    ["EditDashboardUser"],
    useRpiGraphqlRequest<EditDashboardUserMutation, EditDashboardUserMutationVariables>(EditDashboardUserDocument),
    options
  );
export const UpdateDashboardUserSettingsDocument = `
    mutation UpdateDashboardUserSettings($settings: JSON!) {
  dashboardUserUpdateSettings(settings: $settings) {
    id
    username
    settings
  }
}
    `;
export const useUpdateDashboardUserSettingsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateDashboardUserSettingsMutation,
    TError,
    UpdateDashboardUserSettingsMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateDashboardUserSettingsMutation, TError, UpdateDashboardUserSettingsMutationVariables, TContext>(
    ["UpdateDashboardUserSettings"],
    useRpiGraphqlRequest<UpdateDashboardUserSettingsMutation, UpdateDashboardUserSettingsMutationVariables>(
      UpdateDashboardUserSettingsDocument
    ),
    options
  );
export const AdminCancelOrderDocument = `
    mutation AdminCancelOrder($input: AdminCancelOrderInputV2!) {
  adminCancelOrderByIdentifierV2(input: $input) {
    customerOrderId
  }
}
    `;
export const useAdminCancelOrderMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<AdminCancelOrderMutation, TError, AdminCancelOrderMutationVariables, TContext>
) =>
  useMutation<AdminCancelOrderMutation, TError, AdminCancelOrderMutationVariables, TContext>(
    ["AdminCancelOrder"],
    useRpiGraphqlRequest<AdminCancelOrderMutation, AdminCancelOrderMutationVariables>(AdminCancelOrderDocument),
    options
  );
export const AdminCancelOrderV2Document = `
    mutation AdminCancelOrderV2($input: AdminCancelOrderInputV2!) {
  adminCancelOrderByIdentifierV2(input: $input) {
    customerOrderId
  }
}
    `;
export const useAdminCancelOrderV2Mutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<AdminCancelOrderV2Mutation, TError, AdminCancelOrderV2MutationVariables, TContext>
) =>
  useMutation<AdminCancelOrderV2Mutation, TError, AdminCancelOrderV2MutationVariables, TContext>(
    ["AdminCancelOrderV2"],
    useRpiGraphqlRequest<AdminCancelOrderV2Mutation, AdminCancelOrderV2MutationVariables>(AdminCancelOrderV2Document),
    options
  );
export const AdminOverridePaymentStatusDocument = `
    mutation AdminOverridePaymentStatus($input: AdminOverridePaymentStatusInput!) {
  adminOverridePaymentStatus(input: $input) {
    customerOrderId
    paymentStatus
  }
}
    `;
export const useAdminOverridePaymentStatusMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AdminOverridePaymentStatusMutation,
    TError,
    AdminOverridePaymentStatusMutationVariables,
    TContext
  >
) =>
  useMutation<AdminOverridePaymentStatusMutation, TError, AdminOverridePaymentStatusMutationVariables, TContext>(
    ["AdminOverridePaymentStatus"],
    useRpiGraphqlRequest<AdminOverridePaymentStatusMutation, AdminOverridePaymentStatusMutationVariables>(
      AdminOverridePaymentStatusDocument
    ),
    options
  );
export const AdminRedriveOrderDocument = `
    mutation AdminRedriveOrder($orderIdentifier: OrderIdentifierInput!) {
  adminRedriveOrderByIdentifier(orderIdentifier: $orderIdentifier) {
    customerOrderId
    status
  }
}
    `;
export const useAdminRedriveOrderMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<AdminRedriveOrderMutation, TError, AdminRedriveOrderMutationVariables, TContext>
) =>
  useMutation<AdminRedriveOrderMutation, TError, AdminRedriveOrderMutationVariables, TContext>(
    ["AdminRedriveOrder"],
    useRpiGraphqlRequest<AdminRedriveOrderMutation, AdminRedriveOrderMutationVariables>(AdminRedriveOrderDocument),
    options
  );
export const AdminReleaseFromHoldingBinDocument = `
    mutation AdminReleaseFromHoldingBin($orderIdentifier: OrderIdentifierInput!) {
  adminReleaseOrderFromHoldingBinByIdentifier(orderIdentifier: $orderIdentifier) {
    customerOrderId
  }
}
    `;
export const useAdminReleaseFromHoldingBinMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AdminReleaseFromHoldingBinMutation,
    TError,
    AdminReleaseFromHoldingBinMutationVariables,
    TContext
  >
) =>
  useMutation<AdminReleaseFromHoldingBinMutation, TError, AdminReleaseFromHoldingBinMutationVariables, TContext>(
    ["AdminReleaseFromHoldingBin"],
    useRpiGraphqlRequest<AdminReleaseFromHoldingBinMutation, AdminReleaseFromHoldingBinMutationVariables>(
      AdminReleaseFromHoldingBinDocument
    ),
    options
  );
export const AdminUpdateOrderStatusDocument = `
    mutation AdminUpdateOrderStatus($orderIdentifier: OrderIdentifierInput!) {
  adminUpdateOrderStatusByIdentifier(orderIdentifier: $orderIdentifier) {
    customerOrderId
  }
}
    `;
export const useAdminUpdateOrderStatusMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AdminUpdateOrderStatusMutation,
    TError,
    AdminUpdateOrderStatusMutationVariables,
    TContext
  >
) =>
  useMutation<AdminUpdateOrderStatusMutation, TError, AdminUpdateOrderStatusMutationVariables, TContext>(
    ["AdminUpdateOrderStatus"],
    useRpiGraphqlRequest<AdminUpdateOrderStatusMutation, AdminUpdateOrderStatusMutationVariables>(
      AdminUpdateOrderStatusDocument
    ),
    options
  );
export const ReprintOrderDocument = `
    mutation ReprintOrder($input: CreateReprintInputByIdentifier!) {
  orderReprintCreateByIdentifier(createReprintInput: $input) {
    customerOrderId
    validations
  }
}
    `;
export const useReprintOrderMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<ReprintOrderMutation, TError, ReprintOrderMutationVariables, TContext>
) =>
  useMutation<ReprintOrderMutation, TError, ReprintOrderMutationVariables, TContext>(
    ["ReprintOrder"],
    useRpiGraphqlRequest<ReprintOrderMutation, ReprintOrderMutationVariables>(ReprintOrderDocument),
    options
  );
export const ReprintOrderV2Document = `
    mutation ReprintOrderV2($input: CreateReprintInputV2ByIdentifier!) {
  orderReprintCreateV2ByIdentifier(createReprintInputV2: $input) {
    customerOrderId
    validations
  }
}
    `;
export const useReprintOrderV2Mutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<ReprintOrderV2Mutation, TError, ReprintOrderV2MutationVariables, TContext>
) =>
  useMutation<ReprintOrderV2Mutation, TError, ReprintOrderV2MutationVariables, TContext>(
    ["ReprintOrderV2"],
    useRpiGraphqlRequest<ReprintOrderV2Mutation, ReprintOrderV2MutationVariables>(ReprintOrderV2Document),
    options
  );
export const CreatePaymentMethodDocument = `
    mutation CreatePaymentMethod($input: BraintreePaymentMethodInput) {
  paymentMethodCreateV2(braintreePaymentMethodInput: $input) {
    __typename
    ... on BraintreePaymentMethodResponse {
      token
    }
    ... on BraintreePaymentMethodRejection {
      message
      verification {
        avsPostalCodeResponseCode
        avsStreetAddressResponseCode
      }
    }
  }
}
    `;
export const useCreatePaymentMethodMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreatePaymentMethodMutation, TError, CreatePaymentMethodMutationVariables, TContext>
) =>
  useMutation<CreatePaymentMethodMutation, TError, CreatePaymentMethodMutationVariables, TContext>(
    ["CreatePaymentMethod"],
    useRpiGraphqlRequest<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(
      CreatePaymentMethodDocument
    ),
    options
  );
export const DeletePaymentMethodDocument = `
    mutation DeletePaymentMethod($paymentMethodToken: String!, $customerPublicId: String!) {
  paymentMethodDelete(
    paymentMethodToken: $paymentMethodToken
    customerPublicId: $customerPublicId
  ) {
    message
  }
}
    `;
export const useDeletePaymentMethodMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<DeletePaymentMethodMutation, TError, DeletePaymentMethodMutationVariables, TContext>
) =>
  useMutation<DeletePaymentMethodMutation, TError, DeletePaymentMethodMutationVariables, TContext>(
    ["DeletePaymentMethod"],
    useRpiGraphqlRequest<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(
      DeletePaymentMethodDocument
    ),
    options
  );
export const EditPaymentMethodDocument = `
    mutation EditPaymentMethod($input: BraintreePaymentMethodEditInput) {
  paymentMethodEdit(braintreePaymentMethodEditInput: $input) {
    token
  }
}
    `;
export const useEditPaymentMethodMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<EditPaymentMethodMutation, TError, EditPaymentMethodMutationVariables, TContext>
) =>
  useMutation<EditPaymentMethodMutation, TError, EditPaymentMethodMutationVariables, TContext>(
    ["EditPaymentMethod"],
    useRpiGraphqlRequest<EditPaymentMethodMutation, EditPaymentMethodMutationVariables>(EditPaymentMethodDocument),
    options
  );
export const EditPaymentMethodV2Document = `
    mutation EditPaymentMethodV2($input: BraintreePaymentMethodEditInput) {
  paymentMethodEditV2(braintreePaymentMethodEditInput: $input) {
    __typename
    ... on BraintreePaymentMethodResponse {
      token
    }
    ... on BraintreePaymentMethodRejection {
      message
      verification {
        avsPostalCodeResponseCode
        avsStreetAddressResponseCode
      }
    }
  }
}
    `;
export const useEditPaymentMethodV2Mutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<EditPaymentMethodV2Mutation, TError, EditPaymentMethodV2MutationVariables, TContext>
) =>
  useMutation<EditPaymentMethodV2Mutation, TError, EditPaymentMethodV2MutationVariables, TContext>(
    ["EditPaymentMethodV2"],
    useRpiGraphqlRequest<EditPaymentMethodV2Mutation, EditPaymentMethodV2MutationVariables>(
      EditPaymentMethodV2Document
    ),
    options
  );
export const SandboxPaymentNotificationDocument = `
    mutation SandboxPaymentNotification($input: SandboxPaymentNotificationInput!) {
  sandboxPaymentNotification(sandboxPaymentNotificationInput: $input) {
    message
    success
  }
}
    `;
export const useSandboxPaymentNotificationMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SandboxPaymentNotificationMutation,
    TError,
    SandboxPaymentNotificationMutationVariables,
    TContext
  >
) =>
  useMutation<SandboxPaymentNotificationMutation, TError, SandboxPaymentNotificationMutationVariables, TContext>(
    ["SandboxPaymentNotification"],
    useRpiGraphqlRequest<SandboxPaymentNotificationMutation, SandboxPaymentNotificationMutationVariables>(
      SandboxPaymentNotificationDocument
    ),
    options
  );
export const AdminTaxReviewDocument = `
    mutation AdminTaxReview($input: TaxReviewInput) {
  adminTaxReview(taxReviewInput: $input) {
    message
    taxApprovalChanged
  }
}
    `;
export const useAdminTaxReviewMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<AdminTaxReviewMutation, TError, AdminTaxReviewMutationVariables, TContext>
) =>
  useMutation<AdminTaxReviewMutation, TError, AdminTaxReviewMutationVariables, TContext>(
    ["AdminTaxReview"],
    useRpiGraphqlRequest<AdminTaxReviewMutation, AdminTaxReviewMutationVariables>(AdminTaxReviewDocument),
    options
  );
export const UploadedFileDeleteDocument = `
    mutation UploadedFileDelete($id: Int!) {
  uploadedFileDelete(id: $id) {
    message
  }
}
    `;
export const useUploadedFileDeleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<UploadedFileDeleteMutation, TError, UploadedFileDeleteMutationVariables, TContext>
) =>
  useMutation<UploadedFileDeleteMutation, TError, UploadedFileDeleteMutationVariables, TContext>(
    ["UploadedFileDelete"],
    useRpiGraphqlRequest<UploadedFileDeleteMutation, UploadedFileDeleteMutationVariables>(UploadedFileDeleteDocument),
    options
  );
export const CreateUploadDocument = `
    mutation CreateUpload($input: CreateUploadInput) {
  uploadCreate(createUploadInput: $input) {
    collectionId
    fileCount
    collectionType
    uploadExpiration
    finishFileUrl
    uploadFiles {
      fileName
      fileSize
      collectionId
      contentType
      fileId
      externalFileId
      multipartUpload {
        key
        uploadId
        parts {
          PartNumber
          uploadUrl
        }
      }
    }
  }
}
    `;
export const useCreateUploadMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreateUploadMutation, TError, CreateUploadMutationVariables, TContext>
) =>
  useMutation<CreateUploadMutation, TError, CreateUploadMutationVariables, TContext>(
    ["CreateUpload"],
    useRpiGraphqlRequest<CreateUploadMutation, CreateUploadMutationVariables>(CreateUploadDocument),
    options
  );
export const ApiCredentialsDocument = `
    query ApiCredentials($limit: Int!, $offset: Int!, $search: ApiCredentialSearch) {
  apiCredentials(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      apiKey
      customerPublicId
      sharedSecret
      description
      webhookSecret
      isSandbox
    }
  }
}
    `;
export const useApiCredentialsQuery = <TData = ApiCredentialsQuery, TError = unknown>(
  variables: ApiCredentialsQueryVariables,
  options?: UseQueryOptions<ApiCredentialsQuery, TError, TData>
) =>
  useQuery<ApiCredentialsQuery, TError, TData>(
    ["ApiCredentials", variables],
    useRpiGraphqlRequest<ApiCredentialsQuery, ApiCredentialsQueryVariables>(ApiCredentialsDocument).bind(
      null,
      variables
    ),
    options
  );
export const ListApiCredentialsDocument = `
    query ListApiCredentials {
  listApiCredentials {
    id
    apiKey
    customerPublicId
    sharedSecret
    description
    settings
    webhookSecret
    isSandbox
  }
}
    `;
export const useListApiCredentialsQuery = <TData = ListApiCredentialsQuery, TError = unknown>(
  variables?: ListApiCredentialsQueryVariables,
  options?: UseQueryOptions<ListApiCredentialsQuery, TError, TData>
) =>
  useQuery<ListApiCredentialsQuery, TError, TData>(
    variables === undefined ? ["ListApiCredentials"] : ["ListApiCredentials", variables],
    useRpiGraphqlRequest<ListApiCredentialsQuery, ListApiCredentialsQueryVariables>(ListApiCredentialsDocument).bind(
      null,
      variables
    ),
    options
  );
export const BulletinsDocument = `
    query Bulletins {
  bulletins {
    paymentMethodMissing
    taxDocumentNotUploaded
    ordersLimit {
      isOrdersLimitActive
      configuredMaxOrdersWithin24h
      numOrdersReceivedUnderLimitLast24h
      configuredLimitQueueSize
      numOrdersInLimitQueue
      numRejectedOrdersQueueFullLast7Days
      isLimitQueueFull
    }
  }
}
    `;
export const useBulletinsQuery = <TData = BulletinsQuery, TError = unknown>(
  variables?: BulletinsQueryVariables,
  options?: UseQueryOptions<BulletinsQuery, TError, TData>
) =>
  useQuery<BulletinsQuery, TError, TData>(
    variables === undefined ? ["Bulletins"] : ["Bulletins", variables],
    useRpiGraphqlRequest<BulletinsQuery, BulletinsQueryVariables>(BulletinsDocument).bind(null, variables),
    options
  );
export const AdminConfigurationDocument = `
    query AdminConfiguration {
  adminConfiguration {
    avalaraTaxConfiguration
    dynamoDbConfiguration
    tasksConfiguration
    uosClientConfiguration
    pdfProcessingConfiguration
    shippingConfiguration
    dataSourceUrl
    nextChargeTime
    git
    holdingBinReleaseInHours
  }
}
    `;
export const useAdminConfigurationQuery = <TData = AdminConfigurationQuery, TError = unknown>(
  variables?: AdminConfigurationQueryVariables,
  options?: UseQueryOptions<AdminConfigurationQuery, TError, TData>
) =>
  useQuery<AdminConfigurationQuery, TError, TData>(
    variables === undefined ? ["AdminConfiguration"] : ["AdminConfiguration", variables],
    useRpiGraphqlRequest<AdminConfigurationQuery, AdminConfigurationQueryVariables>(AdminConfigurationDocument).bind(
      null,
      variables
    ),
    options
  );
export const NextChargeTimeDocument = `
    query NextChargeTime($customerPublicId: String!) {
  getNextChargeTime(customerPublicId: $customerPublicId)
}
    `;
export const useNextChargeTimeQuery = <TData = NextChargeTimeQuery, TError = unknown>(
  variables: NextChargeTimeQueryVariables,
  options?: UseQueryOptions<NextChargeTimeQuery, TError, TData>
) =>
  useQuery<NextChargeTimeQuery, TError, TData>(
    ["NextChargeTime", variables],
    useRpiGraphqlRequest<NextChargeTimeQuery, NextChargeTimeQueryVariables>(NextChargeTimeDocument).bind(
      null,
      variables
    ),
    options
  );
export const AdminSearchCustomerCommunicationsDocument = `
    query AdminSearchCustomerCommunications($limit: Int!, $offset: Int!, $search: CustomerCommunicationSearch) {
  adminSearchCustomerCommunications(
    limit: $limit
    offset: $offset
    search: $search
  ) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      email
      customer {
        publicId
      }
      type
      createdAt
      contents
    }
  }
}
    `;
export const useAdminSearchCustomerCommunicationsQuery = <
  TData = AdminSearchCustomerCommunicationsQuery,
  TError = unknown
>(
  variables: AdminSearchCustomerCommunicationsQueryVariables,
  options?: UseQueryOptions<AdminSearchCustomerCommunicationsQuery, TError, TData>
) =>
  useQuery<AdminSearchCustomerCommunicationsQuery, TError, TData>(
    ["AdminSearchCustomerCommunications", variables],
    useRpiGraphqlRequest<AdminSearchCustomerCommunicationsQuery, AdminSearchCustomerCommunicationsQueryVariables>(
      AdminSearchCustomerCommunicationsDocument
    ).bind(null, variables),
    options
  );
export const CustomerCommunicationDocument = `
    query CustomerCommunication($id: Int!) {
  customerCommunication(id: $id) {
    id
    email
    customer {
      publicId
    }
    type
    createdAt
    contents
  }
}
    `;
export const useCustomerCommunicationQuery = <TData = CustomerCommunicationQuery, TError = unknown>(
  variables: CustomerCommunicationQueryVariables,
  options?: UseQueryOptions<CustomerCommunicationQuery, TError, TData>
) =>
  useQuery<CustomerCommunicationQuery, TError, TData>(
    ["CustomerCommunication", variables],
    useRpiGraphqlRequest<CustomerCommunicationQuery, CustomerCommunicationQueryVariables>(
      CustomerCommunicationDocument
    ).bind(null, variables),
    options
  );
export const CustomerProductDocument = `
    query CustomerProduct($id: Int!) {
  customerProduct(id: $id) {
    id
    customerPublicId
    customerSku
    name
    description
    openapiProductId
    createdAt
  }
}
    `;
export const useCustomerProductQuery = <TData = CustomerProductQuery, TError = unknown>(
  variables: CustomerProductQueryVariables,
  options?: UseQueryOptions<CustomerProductQuery, TError, TData>
) =>
  useQuery<CustomerProductQuery, TError, TData>(
    ["CustomerProduct", variables],
    useRpiGraphqlRequest<CustomerProductQuery, CustomerProductQueryVariables>(CustomerProductDocument).bind(
      null,
      variables
    ),
    options
  );
export const CustomerProductsDocument = `
    query CustomerProducts($limit: Int!, $offset: Int!, $search: CustomerProductSearch) {
  customerProducts(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      customerPublicId
      customerSku
      name
      description
      openapiProductId
      openapiProduct {
        openapiSku
        productPricing {
          currency
          basePrice
          perPageCost
        }
      }
    }
  }
}
    `;
export const useCustomerProductsQuery = <TData = CustomerProductsQuery, TError = unknown>(
  variables: CustomerProductsQueryVariables,
  options?: UseQueryOptions<CustomerProductsQuery, TError, TData>
) =>
  useQuery<CustomerProductsQuery, TError, TData>(
    ["CustomerProducts", variables],
    useRpiGraphqlRequest<CustomerProductsQuery, CustomerProductsQueryVariables>(CustomerProductsDocument).bind(
      null,
      variables
    ),
    options
  );
export const CustomerProductsSuperAdminDocument = `
    query CustomerProductsSuperAdmin($limit: Int!, $offset: Int!, $search: CustomerProductSearch) {
  customerProducts(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      customer {
        publicId
        organizationName
      }
      customerPublicId
      customerSku
      name
      description
      openapiProductId
      openapiProduct {
        openapiSku
        productPricing {
          currency
          basePrice
          perPageCost
        }
      }
    }
  }
}
    `;
export const useCustomerProductsSuperAdminQuery = <TData = CustomerProductsSuperAdminQuery, TError = unknown>(
  variables: CustomerProductsSuperAdminQueryVariables,
  options?: UseQueryOptions<CustomerProductsSuperAdminQuery, TError, TData>
) =>
  useQuery<CustomerProductsSuperAdminQuery, TError, TData>(
    ["CustomerProductsSuperAdmin", variables],
    useRpiGraphqlRequest<CustomerProductsSuperAdminQuery, CustomerProductsSuperAdminQueryVariables>(
      CustomerProductsSuperAdminDocument
    ).bind(null, variables),
    options
  );
export const ListCustomerProductsDocument = `
    query ListCustomerProducts {
  listCustomerProducts {
    id
    customerPublicId
    customerSku
    name
    description
    openapiProductId
    openapiProduct {
      openapiSku
    }
  }
}
    `;
export const useListCustomerProductsQuery = <TData = ListCustomerProductsQuery, TError = unknown>(
  variables?: ListCustomerProductsQueryVariables,
  options?: UseQueryOptions<ListCustomerProductsQuery, TError, TData>
) =>
  useQuery<ListCustomerProductsQuery, TError, TData>(
    variables === undefined ? ["ListCustomerProducts"] : ["ListCustomerProducts", variables],
    useRpiGraphqlRequest<ListCustomerProductsQuery, ListCustomerProductsQueryVariables>(
      ListCustomerProductsDocument
    ).bind(null, variables),
    options
  );
export const AdminListCustomersDocument = `
    query AdminListCustomers($input: String) {
  adminListCustomers(generalInput: $input) {
    id
    publicId
    email
    createdAt
  }
}
    `;
export const useAdminListCustomersQuery = <TData = AdminListCustomersQuery, TError = unknown>(
  variables?: AdminListCustomersQueryVariables,
  options?: UseQueryOptions<AdminListCustomersQuery, TError, TData>
) =>
  useQuery<AdminListCustomersQuery, TError, TData>(
    variables === undefined ? ["AdminListCustomers"] : ["AdminListCustomers", variables],
    useRpiGraphqlRequest<AdminListCustomersQuery, AdminListCustomersQueryVariables>(AdminListCustomersDocument).bind(
      null,
      variables
    ),
    options
  );
export const AdminSearchCustomersDocument = `
    query AdminSearchCustomers($limit: Int!, $offset: Int!, $search: CustomerSearch) {
  adminSearchCustomers(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      publicId
      email
      pdfProcessingApiaccount
      createdAt
    }
  }
}
    `;
export const useAdminSearchCustomersQuery = <TData = AdminSearchCustomersQuery, TError = unknown>(
  variables: AdminSearchCustomersQueryVariables,
  options?: UseQueryOptions<AdminSearchCustomersQuery, TError, TData>
) =>
  useQuery<AdminSearchCustomersQuery, TError, TData>(
    ["AdminSearchCustomers", variables],
    useRpiGraphqlRequest<AdminSearchCustomersQuery, AdminSearchCustomersQueryVariables>(
      AdminSearchCustomersDocument
    ).bind(null, variables),
    options
  );
export const AdminSearchCustomersForFilterDocument = `
    query AdminSearchCustomersForFilter($limit: Int!, $offset: Int!, $search: CustomerSearch) {
  adminSearchCustomers(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      publicId
      organizationName
    }
  }
}
    `;
export const useAdminSearchCustomersForFilterQuery = <TData = AdminSearchCustomersForFilterQuery, TError = unknown>(
  variables: AdminSearchCustomersForFilterQueryVariables,
  options?: UseQueryOptions<AdminSearchCustomersForFilterQuery, TError, TData>
) =>
  useQuery<AdminSearchCustomersForFilterQuery, TError, TData>(
    ["AdminSearchCustomersForFilter", variables],
    useRpiGraphqlRequest<AdminSearchCustomersForFilterQuery, AdminSearchCustomersForFilterQueryVariables>(
      AdminSearchCustomersForFilterDocument
    ).bind(null, variables),
    options
  );
export const BillingCustomerDocument = `
    query BillingCustomer($customerPublicId: String!) {
  customer(customerPublicId: $customerPublicId) {
    id
    publicId
    chargeTax
    taxDocuments {
      id
      collectionId
      status
      fileName
      contentType
      url
      description
      createdAt
      updatedAt
    }
  }
}
    `;
export const useBillingCustomerQuery = <TData = BillingCustomerQuery, TError = unknown>(
  variables: BillingCustomerQueryVariables,
  options?: UseQueryOptions<BillingCustomerQuery, TError, TData>
) =>
  useQuery<BillingCustomerQuery, TError, TData>(
    ["BillingCustomer", variables],
    useRpiGraphqlRequest<BillingCustomerQuery, BillingCustomerQueryVariables>(BillingCustomerDocument).bind(
      null,
      variables
    ),
    options
  );
export const CustomerDocument = `
    query Customer($customerPublicId: String!) {
  customer(customerPublicId: $customerPublicId) {
    id
    publicId
    pdfProcessingApiaccount
    email
    emailUpdates
    settings {
      shipping
      payments
      pricing
      ordersLimit {
        limitQueueSize
        maxOrders
      }
      allowPrintAssetCreation
      allowCreateOrderFromPrintAsset
      allowInstantPayment
      allowMultipleCurrencies
      vaultCustomerId
    }
    secretKey
    dashboardUsers {
      id
      username
      sub
      email
      disabled
      role
      createdAt
    }
    chargeTax
    createdAt
    taxDocuments {
      id
      collectionId
      status
      fileName
      contentType
      url
      description
      createdAt
      updatedAt
    }
  }
}
    `;
export const useCustomerQuery = <TData = CustomerQuery, TError = unknown>(
  variables: CustomerQueryVariables,
  options?: UseQueryOptions<CustomerQuery, TError, TData>
) =>
  useQuery<CustomerQuery, TError, TData>(
    ["Customer", variables],
    useRpiGraphqlRequest<CustomerQuery, CustomerQueryVariables>(CustomerDocument).bind(null, variables),
    options
  );
export const CustomerAdminRolesDocument = `
    query CustomerAdminRoles($customerPublicId: String!) {
  customer(customerPublicId: $customerPublicId) {
    publicId
    dashboardUsers {
      id
      role
    }
  }
}
    `;
export const useCustomerAdminRolesQuery = <TData = CustomerAdminRolesQuery, TError = unknown>(
  variables: CustomerAdminRolesQueryVariables,
  options?: UseQueryOptions<CustomerAdminRolesQuery, TError, TData>
) =>
  useQuery<CustomerAdminRolesQuery, TError, TData>(
    ["CustomerAdminRoles", variables],
    useRpiGraphqlRequest<CustomerAdminRolesQuery, CustomerAdminRolesQueryVariables>(CustomerAdminRolesDocument).bind(
      null,
      variables
    ),
    options
  );
export const PaymentOrganizationDocument = `
    query PaymentOrganization($customerPublicId: String!) {
  customer(customerPublicId: $customerPublicId) {
    publicId
    organizationName
  }
}
    `;
export const usePaymentOrganizationQuery = <TData = PaymentOrganizationQuery, TError = unknown>(
  variables: PaymentOrganizationQueryVariables,
  options?: UseQueryOptions<PaymentOrganizationQuery, TError, TData>
) =>
  useQuery<PaymentOrganizationQuery, TError, TData>(
    ["PaymentOrganization", variables],
    useRpiGraphqlRequest<PaymentOrganizationQuery, PaymentOrganizationQueryVariables>(PaymentOrganizationDocument).bind(
      null,
      variables
    ),
    options
  );
export const DashboardUserDocument = `
    query DashboardUser($id: Int!) {
  dashboardUser(id: $id) {
    id
    username
    sub
    email
    disabled
    customerPublicId
    role
    firstName
    lastName
    createdAt
  }
}
    `;
export const useDashboardUserQuery = <TData = DashboardUserQuery, TError = unknown>(
  variables: DashboardUserQueryVariables,
  options?: UseQueryOptions<DashboardUserQuery, TError, TData>
) =>
  useQuery<DashboardUserQuery, TError, TData>(
    ["DashboardUser", variables],
    useRpiGraphqlRequest<DashboardUserQuery, DashboardUserQueryVariables>(DashboardUserDocument).bind(null, variables),
    options
  );
export const DashboardUserCurrentDocument = `
    query DashboardUserCurrent {
  dashboardUserCurrent {
    id
    username
    sub
    email
    disabled
    customerPublicId
    role
    firstName
    lastName
    createdAt
    settings
    customer {
      isOnboardingComplete
      organizationName
      organization {
        website
        size
        country
      }
      settings {
        ordersLimit {
          maxOrders
          limitQueueSize
        }
      }
    }
  }
}
    `;
export const useDashboardUserCurrentQuery = <TData = DashboardUserCurrentQuery, TError = unknown>(
  variables?: DashboardUserCurrentQueryVariables,
  options?: UseQueryOptions<DashboardUserCurrentQuery, TError, TData>
) =>
  useQuery<DashboardUserCurrentQuery, TError, TData>(
    variables === undefined ? ["DashboardUserCurrent"] : ["DashboardUserCurrent", variables],
    useRpiGraphqlRequest<DashboardUserCurrentQuery, DashboardUserCurrentQueryVariables>(
      DashboardUserCurrentDocument
    ).bind(null, variables),
    options
  );
export const DashboardUsersDocument = `
    query DashboardUsers($limit: Int!, $offset: Int!, $search: DashboardUserSearch) {
  dashboardUsers(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      username
      sub
      email
      disabled
      customerPublicId
      customer {
        publicId
        organizationName
      }
      role
      firstName
      lastName
      createdAt
    }
  }
}
    `;
export const useDashboardUsersQuery = <TData = DashboardUsersQuery, TError = unknown>(
  variables: DashboardUsersQueryVariables,
  options?: UseQueryOptions<DashboardUsersQuery, TError, TData>
) =>
  useQuery<DashboardUsersQuery, TError, TData>(
    ["DashboardUsers", variables],
    useRpiGraphqlRequest<DashboardUsersQuery, DashboardUsersQueryVariables>(DashboardUsersDocument).bind(
      null,
      variables
    ),
    options
  );
export const DailyMetricsDocument = `
    query DailyMetrics($customerPublicId: String!, $numberOfDays: Int!) {
  dailyMetrics(customerPublicId: $customerPublicId, numberOfDays: $numberOfDays) {
    customerPublicId
    numberOfDays
    days {
      createdDay
      sumOrderTotals
      numCreatedOrders
    }
  }
}
    `;
export const useDailyMetricsQuery = <TData = DailyMetricsQuery, TError = unknown>(
  variables: DailyMetricsQueryVariables,
  options?: UseQueryOptions<DailyMetricsQuery, TError, TData>
) =>
  useQuery<DailyMetricsQuery, TError, TData>(
    ["DailyMetrics", variables],
    useRpiGraphqlRequest<DailyMetricsQuery, DailyMetricsQueryVariables>(DailyMetricsDocument).bind(null, variables),
    options
  );
export const DailyPaymentMetricsDocument = `
    query DailyPaymentMetrics($customerPublicId: String!, $numberOfDays: Int!) {
  dailyPaymentMetrics(
    customerPublicId: $customerPublicId
    numberOfDays: $numberOfDays
  ) {
    customerPublicId
    numberOfDays
    days {
      createdDay
      sumSaleTotals
      sumRefundTotals
    }
  }
}
    `;
export const useDailyPaymentMetricsQuery = <TData = DailyPaymentMetricsQuery, TError = unknown>(
  variables: DailyPaymentMetricsQueryVariables,
  options?: UseQueryOptions<DailyPaymentMetricsQuery, TError, TData>
) =>
  useQuery<DailyPaymentMetricsQuery, TError, TData>(
    ["DailyPaymentMetrics", variables],
    useRpiGraphqlRequest<DailyPaymentMetricsQuery, DailyPaymentMetricsQueryVariables>(DailyPaymentMetricsDocument).bind(
      null,
      variables
    ),
    options
  );
export const OrdersByPublicStatusMetricsDocument = `
    query OrdersByPublicStatusMetrics($customerPublicId: String!, $numberOfDays: Int!) {
  ordersByPublicStatusMetrics(
    customerPublicId: $customerPublicId
    numberOfDays: $numberOfDays
  ) {
    customerPublicId
    numberOfDays
    ordersByPublicStatus {
      publicStatus
      numOrders
    }
  }
}
    `;
export const useOrdersByPublicStatusMetricsQuery = <TData = OrdersByPublicStatusMetricsQuery, TError = unknown>(
  variables: OrdersByPublicStatusMetricsQueryVariables,
  options?: UseQueryOptions<OrdersByPublicStatusMetricsQuery, TError, TData>
) =>
  useQuery<OrdersByPublicStatusMetricsQuery, TError, TData>(
    ["OrdersByPublicStatusMetrics", variables],
    useRpiGraphqlRequest<OrdersByPublicStatusMetricsQuery, OrdersByPublicStatusMetricsQueryVariables>(
      OrdersByPublicStatusMetricsDocument
    ).bind(null, variables),
    options
  );
export const OrdersChartDocument = `
    query OrdersChart($isSandbox: Boolean!, $timezone: String!, $year: Int!) {
  ordersChart(isSandbox: $isSandbox, timezone: $timezone, year: $year) {
    availableYears
    dataPoints {
      month
      statusCounts {
        status
        count
      }
    }
  }
}
    `;
export const useOrdersChartQuery = <TData = OrdersChartQuery, TError = unknown>(
  variables: OrdersChartQueryVariables,
  options?: UseQueryOptions<OrdersChartQuery, TError, TData>
) =>
  useQuery<OrdersChartQuery, TError, TData>(
    ["OrdersChart", variables],
    useRpiGraphqlRequest<OrdersChartQuery, OrdersChartQueryVariables>(OrdersChartDocument).bind(null, variables),
    options
  );
export const PaymentsChartDocument = `
    query PaymentsChart($isSandbox: Boolean!, $timezone: String!, $year: Int!) {
  paymentsChart(isSandbox: $isSandbox, timezone: $timezone, year: $year) {
    availableYears
    nextChargeDate
    dataPoints {
      month
      netPaymentAmount
      currency
    }
  }
}
    `;
export const usePaymentsChartQuery = <TData = PaymentsChartQuery, TError = unknown>(
  variables: PaymentsChartQueryVariables,
  options?: UseQueryOptions<PaymentsChartQuery, TError, TData>
) =>
  useQuery<PaymentsChartQuery, TError, TData>(
    ["PaymentsChart", variables],
    useRpiGraphqlRequest<PaymentsChartQuery, PaymentsChartQueryVariables>(PaymentsChartDocument).bind(null, variables),
    options
  );
export const ListOpenApiProductsDocument = `
    query ListOpenApiProducts($hideAlreadyAssociatedProducts: Boolean) {
  listOpenApiProducts(
    hideAlreadyAssociatedProducts: $hideAlreadyAssociatedProducts
  ) {
    id
    name
    openapiSku
    skuAttributes
    productPricing {
      currency
      basePrice
      perPageCost
    }
    productSpecification {
      specification
    }
  }
}
    `;
export const useListOpenApiProductsQuery = <TData = ListOpenApiProductsQuery, TError = unknown>(
  variables?: ListOpenApiProductsQueryVariables,
  options?: UseQueryOptions<ListOpenApiProductsQuery, TError, TData>
) =>
  useQuery<ListOpenApiProductsQuery, TError, TData>(
    variables === undefined ? ["ListOpenApiProducts"] : ["ListOpenApiProducts", variables],
    useRpiGraphqlRequest<ListOpenApiProductsQuery, ListOpenApiProductsQueryVariables>(ListOpenApiProductsDocument).bind(
      null,
      variables
    ),
    options
  );
export const OpenApiProductDocument = `
    query OpenApiProduct($id: Int!) {
  openapiProduct(id: $id) {
    id
    uosSku
    openapiSku
    uosMediaOption
    uosOrientation
    name
    description
    skuAttributes
    productPricing {
      currency
      basePrice
      perPageCost
    }
    enabled
    productSpecification {
      specification
    }
  }
}
    `;
export const useOpenApiProductQuery = <TData = OpenApiProductQuery, TError = unknown>(
  variables: OpenApiProductQueryVariables,
  options?: UseQueryOptions<OpenApiProductQuery, TError, TData>
) =>
  useQuery<OpenApiProductQuery, TError, TData>(
    ["OpenApiProduct", variables],
    useRpiGraphqlRequest<OpenApiProductQuery, OpenApiProductQueryVariables>(OpenApiProductDocument).bind(
      null,
      variables
    ),
    options
  );
export const OpenApiProductWithPricingDocument = `
    query OpenApiProductWithPricing($id: Int!) {
  openapiProduct(id: $id) {
    productPricing {
      currency
      basePrice
      perPageCost
    }
    productSpecification {
      specification
    }
  }
}
    `;
export const useOpenApiProductWithPricingQuery = <TData = OpenApiProductWithPricingQuery, TError = unknown>(
  variables: OpenApiProductWithPricingQueryVariables,
  options?: UseQueryOptions<OpenApiProductWithPricingQuery, TError, TData>
) =>
  useQuery<OpenApiProductWithPricingQuery, TError, TData>(
    ["OpenApiProductWithPricing", variables],
    useRpiGraphqlRequest<OpenApiProductWithPricingQuery, OpenApiProductWithPricingQueryVariables>(
      OpenApiProductWithPricingDocument
    ).bind(null, variables),
    options
  );
export const OpenApiProductsDocument = `
    query OpenApiProducts($limit: Int!, $offset: Int!, $search: OpenapiProductSearch) {
  openapiProducts(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      uosSku
      openapiSku
      uosMediaOption
      uosOrientation
      name
      description
      skuAttributes
    }
  }
}
    `;
export const useOpenApiProductsQuery = <TData = OpenApiProductsQuery, TError = unknown>(
  variables: OpenApiProductsQueryVariables,
  options?: UseQueryOptions<OpenApiProductsQuery, TError, TData>
) =>
  useQuery<OpenApiProductsQuery, TError, TData>(
    ["OpenApiProducts", variables],
    useRpiGraphqlRequest<OpenApiProductsQuery, OpenApiProductsQueryVariables>(OpenApiProductsDocument).bind(
      null,
      variables
    ),
    options
  );
export const CalculateRefundByAmountDocument = `
    query CalculateRefundByAmount($customerPublicId: String!, $input: BraintreeRefundByAmountInput!) {
  calculateRefundByAmount(customerPublicId: $customerPublicId, input: $input) {
    refundSubtotal
    refundTax
    totalRefund
    lineItems {
      id
      quantity
      unitPrice
      refundAmount
      refundTax
    }
  }
}
    `;
export const useCalculateRefundByAmountQuery = <TData = CalculateRefundByAmountQuery, TError = unknown>(
  variables: CalculateRefundByAmountQueryVariables,
  options?: UseQueryOptions<CalculateRefundByAmountQuery, TError, TData>
) =>
  useQuery<CalculateRefundByAmountQuery, TError, TData>(
    ["CalculateRefundByAmount", variables],
    useRpiGraphqlRequest<CalculateRefundByAmountQuery, CalculateRefundByAmountQueryVariables>(
      CalculateRefundByAmountDocument
    ).bind(null, variables),
    options
  );
export const CalculateRefundByPercentageDocument = `
    query CalculateRefundByPercentage($customerPublicId: String!, $input: BraintreeRefundByPercentageInput!) {
  calculateRefundByPercentage(customerPublicId: $customerPublicId, input: $input) {
    refundSubtotal
    refundTax
    totalRefund
    lineItems {
      id
      quantity
      unitPrice
      refundAmount
      refundTax
    }
  }
}
    `;
export const useCalculateRefundByPercentageQuery = <TData = CalculateRefundByPercentageQuery, TError = unknown>(
  variables: CalculateRefundByPercentageQueryVariables,
  options?: UseQueryOptions<CalculateRefundByPercentageQuery, TError, TData>
) =>
  useQuery<CalculateRefundByPercentageQuery, TError, TData>(
    ["CalculateRefundByPercentage", variables],
    useRpiGraphqlRequest<CalculateRefundByPercentageQuery, CalculateRefundByPercentageQueryVariables>(
      CalculateRefundByPercentageDocument
    ).bind(null, variables),
    options
  );
export const CalculateRefundByQuantityDocument = `
    query CalculateRefundByQuantity($customerPublicId: String!, $input: BraintreeRefundByQuantityInput!) {
  calculateRefundByQuantity(customerPublicId: $customerPublicId, input: $input) {
    refundSubtotal
    refundTax
    totalRefund
    lineItems {
      id
      quantity
      unitPrice
      refundAmount
      refundTax
    }
  }
}
    `;
export const useCalculateRefundByQuantityQuery = <TData = CalculateRefundByQuantityQuery, TError = unknown>(
  variables: CalculateRefundByQuantityQueryVariables,
  options?: UseQueryOptions<CalculateRefundByQuantityQuery, TError, TData>
) =>
  useQuery<CalculateRefundByQuantityQuery, TError, TData>(
    ["CalculateRefundByQuantity", variables],
    useRpiGraphqlRequest<CalculateRefundByQuantityQuery, CalculateRefundByQuantityQueryVariables>(
      CalculateRefundByQuantityDocument
    ).bind(null, variables),
    options
  );
export const ListOrdersForPaymentDocument = `
    query ListOrdersForPayment($customerPublicId: String!) {
  listOrdersForPayment(customerPublicId: $customerPublicId) {
    customerOrderId
    createdAt
    updatedAt
    pricing {
      orderTotal
      itemsTotal
      taxesTotal
      shippingTotal
      currency
    }
  }
}
    `;
export const useListOrdersForPaymentQuery = <TData = ListOrdersForPaymentQuery, TError = unknown>(
  variables: ListOrdersForPaymentQueryVariables,
  options?: UseQueryOptions<ListOrdersForPaymentQuery, TError, TData>
) =>
  useQuery<ListOrdersForPaymentQuery, TError, TData>(
    ["ListOrdersForPayment", variables],
    useRpiGraphqlRequest<ListOrdersForPaymentQuery, ListOrdersForPaymentQueryVariables>(
      ListOrdersForPaymentDocument
    ).bind(null, variables),
    options
  );
export const OrderDocument = `
    query Order($orderIdentifier: OrderIdentifierInput!, $isSandbox: Boolean!) {
  orderByIdentifier(orderIdentifier: $orderIdentifier, isSandbox: $isSandbox) {
    id
    customer {
      id
      publicId
      email
    }
    reprintParentCustomerPublicId
    reprintParentCustomerOrderId
    customerOrderId
    paymentStatus
    publicOrderStatus
    status
    canReprint
    createdAt
    updatedAt
    submittedAt
    paymentMode
    currency
    webhookUri
    lastStatusMessage
    destination {
      id
      shippingMethodCode
      shippingDetails
      address {
        id
        createdAt
        updatedAt
        name
        company
        address1
        address2
        address3
        postalCode
        city
        regionIso
        countryIso
        phone
        email
      }
    }
    orderEvents {
      id
      customerOrderId
      eventTime
      eventType
      shortDesc
      data
    }
    validationResult
    additionalPayload
    callbacks {
      urlEndpoint
      attemptCount
      webhookId
      webhookStatus
      timeline
      body
    }
    orderItems {
      id
      openapiProduct {
        id
        uosSku
        openapiSku
        uosMediaOption
        uosOrientation
        name
        description
        productSpecification {
          id
          name
          type
          version
          md5Hash
          processingTemplate
          processingSettings
        }
      }
      customerProduct {
        id
        customerPublicId
        customerSku
        name
        description
        openapiProductId
      }
      printAsset {
        id
        customer {
          id
          publicId
          email
        }
        printAssetUploadId
        status
        previews
        preflightOutputFiles
      }
      orderItemStatus
      pagecount
      coverUri
      gutsUri
      imageUri
      validationResult
      pricingAlgorithm
      pricingDetails
      quantity
      unitPrice
    }
    pricing {
      currency
      itemsTotal
      orderTotal
      shippingTotal
      taxesTotal
    }
    canDoFullRefund
    canRefund
    remainingPossibleRefund
    shipments {
      id
      status
      isFinalShipment
      shippedDate
      shippingMethodCode
      trackingNumber
      masterTrackingNumber
      secondaryTrackingNumber
      rawShipmentData
      destination {
        id
        shippingMethodCode
        shippingDetails
        address {
          id
          createdAt
          updatedAt
          name
          company
          address1
          address2
          address3
          postalCode
          city
          regionIso
          countryIso
          phone
          email
        }
      }
      orderItems {
        id
        quantity
        pagecount
        unitPrice
        coverUri
        gutsUri
        imageUri
        orderItemStatus
        validationResult
        customerProduct {
          id
          customerSku
          name
          description
        }
        openapiProduct {
          id
          openapiSku
          name
        }
        printAsset {
          id
          status
          preflightOutputFiles
        }
      }
    }
    salePayment {
      id
    }
    refunds {
      id
      saleParentPaymentId
      customerPublicId
      braintreeTransactionId
      amount
      currency
      transactionType
      createdAt
    }
    isSandbox
  }
}
    `;
export const useOrderQuery = <TData = OrderQuery, TError = unknown>(
  variables: OrderQueryVariables,
  options?: UseQueryOptions<OrderQuery, TError, TData>
) =>
  useQuery<OrderQuery, TError, TData>(
    ["Order", variables],
    useRpiGraphqlRequest<OrderQuery, OrderQueryVariables>(OrderDocument).bind(null, variables),
    options
  );
export const OrderCallbacksDocument = `
    query OrderCallbacks($orderIdentifier: OrderIdentifierInput!, $isSandbox: Boolean!) {
  orderByIdentifier(orderIdentifier: $orderIdentifier, isSandbox: $isSandbox) {
    callbacks {
      body
      webhookStatus
      urlEndpoint
      attemptCount
      webhookId
      timeline
    }
  }
}
    `;
export const useOrderCallbacksQuery = <TData = OrderCallbacksQuery, TError = unknown>(
  variables: OrderCallbacksQueryVariables,
  options?: UseQueryOptions<OrderCallbacksQuery, TError, TData>
) =>
  useQuery<OrderCallbacksQuery, TError, TData>(
    ["OrderCallbacks", variables],
    useRpiGraphqlRequest<OrderCallbacksQuery, OrderCallbacksQueryVariables>(OrderCallbacksDocument).bind(
      null,
      variables
    ),
    options
  );
export const OrderDetailsDocument = `
    query OrderDetails($orderIdentifier: OrderIdentifierInput!, $isSandbox: Boolean!) {
  orderByIdentifier(orderIdentifier: $orderIdentifier, isSandbox: $isSandbox) {
    paymentStatus
    createdAt
    submittedAt
    lastStatusMessage
    reprintParentCustomerOrderId
    reprintParentCustomerPublicId
    customer {
      organizationName
    }
    pricing {
      currency
      itemsTotal
      shippingTotal
      taxesTotal
      orderTotal
    }
    salePayment {
      id
      createdAt
      paymentMethodLabel
    }
    refunds {
      id
      amount
      createdAt
      refundDetails {
        strategy
        itemsRefundAmount
        shippingRefundAmount
        taxesRefundAmount
        reason
        reasonNote
      }
    }
  }
}
    `;
export const useOrderDetailsQuery = <TData = OrderDetailsQuery, TError = unknown>(
  variables: OrderDetailsQueryVariables,
  options?: UseQueryOptions<OrderDetailsQuery, TError, TData>
) =>
  useQuery<OrderDetailsQuery, TError, TData>(
    ["OrderDetails", variables],
    useRpiGraphqlRequest<OrderDetailsQuery, OrderDetailsQueryVariables>(OrderDetailsDocument).bind(null, variables),
    options
  );
export const OrderEventsDocument = `
    query OrderEvents($orderIdentifier: OrderIdentifierInput!, $isSandbox: Boolean!, $isSuperAdmin: Boolean!) {
  orderByIdentifier(orderIdentifier: $orderIdentifier, isSandbox: $isSandbox) {
    orderEvents {
      eventTime
      eventType
      shortDesc
      data @include(if: $isSuperAdmin)
      webhookSourceName @include(if: $isSuperAdmin)
    }
  }
}
    `;
export const useOrderEventsQuery = <TData = OrderEventsQuery, TError = unknown>(
  variables: OrderEventsQueryVariables,
  options?: UseQueryOptions<OrderEventsQuery, TError, TData>
) =>
  useQuery<OrderEventsQuery, TError, TData>(
    ["OrderEvents", variables],
    useRpiGraphqlRequest<OrderEventsQuery, OrderEventsQueryVariables>(OrderEventsDocument).bind(null, variables),
    options
  );
export const OrderItemsDocument = `
    query OrderItems($orderIdentifier: OrderIdentifierInput!, $isSandbox: Boolean!) {
  orderByIdentifier(orderIdentifier: $orderIdentifier, isSandbox: $isSandbox) {
    currency
    orderItems {
      ...OrderItemFields
    }
  }
}
    ${OrderItemFieldsFragmentDoc}`;
export const useOrderItemsQuery = <TData = OrderItemsQuery, TError = unknown>(
  variables: OrderItemsQueryVariables,
  options?: UseQueryOptions<OrderItemsQuery, TError, TData>
) =>
  useQuery<OrderItemsQuery, TError, TData>(
    ["OrderItems", variables],
    useRpiGraphqlRequest<OrderItemsQuery, OrderItemsQueryVariables>(OrderItemsDocument).bind(null, variables),
    options
  );
export const OrderMinimalDocument = `
    query OrderMinimal($orderIdentifier: OrderIdentifierInput!, $isSandbox: Boolean!) {
  orderByIdentifier(orderIdentifier: $orderIdentifier, isSandbox: $isSandbox) {
    customerOrderId
    orderPublicId
    uosOrderId
    paymentStatus
    publicOrderStatus
    status
    canRefund
    canReprint
    customer {
      publicId
    }
  }
}
    `;
export const useOrderMinimalQuery = <TData = OrderMinimalQuery, TError = unknown>(
  variables: OrderMinimalQueryVariables,
  options?: UseQueryOptions<OrderMinimalQuery, TError, TData>
) =>
  useQuery<OrderMinimalQuery, TError, TData>(
    ["OrderMinimal", variables],
    useRpiGraphqlRequest<OrderMinimalQuery, OrderMinimalQueryVariables>(OrderMinimalDocument).bind(null, variables),
    options
  );
export const OrderRefundReprintInfoDocument = `
    query OrderRefundReprintInfo($orderIdentifier: OrderIdentifierInput!, $isSandbox: Boolean!) {
  orderByIdentifier(orderIdentifier: $orderIdentifier, isSandbox: $isSandbox) {
    customerOrderId
    currency
    pricing {
      itemsTotal
      shippingTotal
      taxesTotal
      orderTotal
    }
    customer {
      publicId
    }
    destination {
      shippingMethodCode
    }
    orderItems {
      id
      openapiProduct {
        name
      }
      customerProduct {
        name
      }
      quantity
    }
  }
}
    `;
export const useOrderRefundReprintInfoQuery = <TData = OrderRefundReprintInfoQuery, TError = unknown>(
  variables: OrderRefundReprintInfoQueryVariables,
  options?: UseQueryOptions<OrderRefundReprintInfoQuery, TError, TData>
) =>
  useQuery<OrderRefundReprintInfoQuery, TError, TData>(
    ["OrderRefundReprintInfo", variables],
    useRpiGraphqlRequest<OrderRefundReprintInfoQuery, OrderRefundReprintInfoQueryVariables>(
      OrderRefundReprintInfoDocument
    ).bind(null, variables),
    options
  );
export const OrderShipmentsDocument = `
    query OrderShipments($orderIdentifier: OrderIdentifierInput!, $isSandbox: Boolean!) {
  orderByIdentifier(orderIdentifier: $orderIdentifier, isSandbox: $isSandbox) {
    currency
    destination {
      id
      address {
        name
        address1
        address2
        address3
        city
        countryIso
        postalCode
        regionIso
        email
        phone
      }
      shippingDetails
    }
    shipments {
      id
      shippingMethodCode
      trackingNumber
      secondaryTrackingNumber
      masterTrackingNumber
      destination {
        address {
          name
          address1
          address2
          address3
          city
          countryIso
          postalCode
          regionIso
          email
          phone
        }
        shippingDetails
      }
      orderItems {
        ...OrderItemFields
      }
    }
  }
}
    ${OrderItemFieldsFragmentDoc}`;
export const useOrderShipmentsQuery = <TData = OrderShipmentsQuery, TError = unknown>(
  variables: OrderShipmentsQueryVariables,
  options?: UseQueryOptions<OrderShipmentsQuery, TError, TData>
) =>
  useQuery<OrderShipmentsQuery, TError, TData>(
    ["OrderShipments", variables],
    useRpiGraphqlRequest<OrderShipmentsQuery, OrderShipmentsQueryVariables>(OrderShipmentsDocument).bind(
      null,
      variables
    ),
    options
  );
export const OrdersDocument = `
    query Orders($limit: Int!, $offset: Int!, $search: OrderSearch) {
  orders(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      ...OrderRowFields
    }
  }
}
    ${OrderRowFieldsFragmentDoc}`;
export const useOrdersQuery = <TData = OrdersQuery, TError = unknown>(
  variables: OrdersQueryVariables,
  options?: UseQueryOptions<OrdersQuery, TError, TData>
) =>
  useQuery<OrdersQuery, TError, TData>(
    ["Orders", variables],
    useRpiGraphqlRequest<OrdersQuery, OrdersQueryVariables>(OrdersDocument).bind(null, variables),
    options
  );
export const ListPaymentMethodsDocument = `
    query ListPaymentMethods($customerPublicId: String!) {
  listPaymentMethods(customerPublicId: $customerPublicId) {
    cardholderName
    address
    city
    state
    countryIso2
    countryName
    name
    imageUrl
    customerId
    message
    token
    isDefault
    last4Digits
    maskedCCNumber
    expiryDate
  }
}
    `;
export const useListPaymentMethodsQuery = <TData = ListPaymentMethodsQuery, TError = unknown>(
  variables: ListPaymentMethodsQueryVariables,
  options?: UseQueryOptions<ListPaymentMethodsQuery, TError, TData>
) =>
  useQuery<ListPaymentMethodsQuery, TError, TData>(
    ["ListPaymentMethods", variables],
    useRpiGraphqlRequest<ListPaymentMethodsQuery, ListPaymentMethodsQueryVariables>(ListPaymentMethodsDocument).bind(
      null,
      variables
    ),
    options
  );
export const PaymentDocument = `
    query Payment($id: Int) {
  payment(id: $id) {
    id
    saleParentPaymentId
    customerPublicId
    braintreeTransactionId
    amount
    currency
    transactionType
    notes
    createdAt
    updatedAt
    paymentInfo
    paidOrders {
      ...OrderRowFields
    }
    refundedOrder {
      customerOrderId
      currency
      canDoFullRefund
      remainingPossibleRefund
      pricing {
        currency
        itemsTotal
        orderTotal
        shippingTotal
        taxesTotal
      }
      customer {
        publicId
      }
      status
      publicOrderStatus
      createdAt
      updatedAt
      submittedAt
      lastStatusMessage
    }
    refundDetails {
      refundedBy {
        firstName
        lastName
        email
      }
    }
  }
}
    ${OrderRowFieldsFragmentDoc}`;
export const usePaymentQuery = <TData = PaymentQuery, TError = unknown>(
  variables?: PaymentQueryVariables,
  options?: UseQueryOptions<PaymentQuery, TError, TData>
) =>
  useQuery<PaymentQuery, TError, TData>(
    variables === undefined ? ["Payment"] : ["Payment", variables],
    useRpiGraphqlRequest<PaymentQuery, PaymentQueryVariables>(PaymentDocument).bind(null, variables),
    options
  );
export const PaymentByTransactionIdDocument = `
    query PaymentByTransactionId($braintreeTransactionId: String) {
  paymentByTransactionId(braintreeTransactionId: $braintreeTransactionId) {
    id
    customerPublicId
    braintreeTransactionId
    amount
    currency
    paymentInfo
    paidOrders {
      customerOrderId
      createdAt
      updatedAt
      pricing {
        currency
        itemsTotal
        orderTotal
        shippingTotal
        taxesTotal
      }
    }
  }
}
    `;
export const usePaymentByTransactionIdQuery = <TData = PaymentByTransactionIdQuery, TError = unknown>(
  variables?: PaymentByTransactionIdQueryVariables,
  options?: UseQueryOptions<PaymentByTransactionIdQuery, TError, TData>
) =>
  useQuery<PaymentByTransactionIdQuery, TError, TData>(
    variables === undefined ? ["PaymentByTransactionId"] : ["PaymentByTransactionId", variables],
    useRpiGraphqlRequest<PaymentByTransactionIdQuery, PaymentByTransactionIdQueryVariables>(
      PaymentByTransactionIdDocument
    ).bind(null, variables),
    options
  );
export const PaymentsDocument = `
    query Payments($limit: Int!, $offset: Int!, $search: PaymentSearch) {
  payments(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      saleParentPaymentId
      customerPublicId
      braintreeTransactionId
      amount
      currency
      transactionType
      createdAt
    }
  }
}
    `;
export const usePaymentsQuery = <TData = PaymentsQuery, TError = unknown>(
  variables: PaymentsQueryVariables,
  options?: UseQueryOptions<PaymentsQuery, TError, TData>
) =>
  useQuery<PaymentsQuery, TError, TData>(
    ["Payments", variables],
    useRpiGraphqlRequest<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument).bind(null, variables),
    options
  );
export const PrintAssetDocument = `
    query PrintAsset($id: Int!) {
  printAsset(id: $id) {
    id
    customer {
      id
      publicId
      pdfProcessingApiaccount
      email
    }
    printAssetUploadId
    status
    previews
    preflightOutputFiles
    report
  }
}
    `;
export const usePrintAssetQuery = <TData = PrintAssetQuery, TError = unknown>(
  variables: PrintAssetQueryVariables,
  options?: UseQueryOptions<PrintAssetQuery, TError, TData>
) =>
  useQuery<PrintAssetQuery, TError, TData>(
    ["PrintAsset", variables],
    useRpiGraphqlRequest<PrintAssetQuery, PrintAssetQueryVariables>(PrintAssetDocument).bind(null, variables),
    options
  );
export const PrintAssetsDocument = `
    query PrintAssets($limit: Int!, $offset: Int!, $search: PrintAssetSearch) {
  printAssets(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      customer {
        publicId
        organizationName
      }
      printAssetUploadId
      status
      updatedAt
    }
  }
}
    `;
export const usePrintAssetsQuery = <TData = PrintAssetsQuery, TError = unknown>(
  variables: PrintAssetsQueryVariables,
  options?: UseQueryOptions<PrintAssetsQuery, TError, TData>
) =>
  useQuery<PrintAssetsQuery, TError, TData>(
    ["PrintAssets", variables],
    useRpiGraphqlRequest<PrintAssetsQuery, PrintAssetsQueryVariables>(PrintAssetsDocument).bind(null, variables),
    options
  );
export const UploadFilesByPollCollectionDocument = `
    query UploadFilesByPollCollection($collectionId: String!, $customerPublicId: String!) {
  uploadFilesPollByCollection(
    collectionId: $collectionId
    customerPublicId: $customerPublicId
  ) {
    id
    customer {
      id
      publicId
    }
    collectionId
    status
    fileName
    contentType
    url
    description
    createdAt
    updatedAt
    isTaxDocument
  }
}
    `;
export const useUploadFilesByPollCollectionQuery = <TData = UploadFilesByPollCollectionQuery, TError = unknown>(
  variables: UploadFilesByPollCollectionQueryVariables,
  options?: UseQueryOptions<UploadFilesByPollCollectionQuery, TError, TData>
) =>
  useQuery<UploadFilesByPollCollectionQuery, TError, TData>(
    ["UploadFilesByPollCollection", variables],
    useRpiGraphqlRequest<UploadFilesByPollCollectionQuery, UploadFilesByPollCollectionQueryVariables>(
      UploadFilesByPollCollectionDocument
    ).bind(null, variables),
    options
  );
export const UploadedFileDocument = `
    query UploadedFile($id: Int!) {
  uploadedFile(id: $id) {
    id
    customer {
      id
      publicId
    }
    collectionId
    status
    fileName
    contentType
    url
    description
    createdAt
    updatedAt
  }
}
    `;
export const useUploadedFileQuery = <TData = UploadedFileQuery, TError = unknown>(
  variables: UploadedFileQueryVariables,
  options?: UseQueryOptions<UploadedFileQuery, TError, TData>
) =>
  useQuery<UploadedFileQuery, TError, TData>(
    ["UploadedFile", variables],
    useRpiGraphqlRequest<UploadedFileQuery, UploadedFileQueryVariables>(UploadedFileDocument).bind(null, variables),
    options
  );
export const UploadedFilesDocument = `
    query UploadedFiles($limit: Int!, $offset: Int!, $search: UploadedFileSearch) {
  uploadedFiles(limit: $limit, offset: $offset, search: $search) {
    totalCount
    offset
    nextOffset
    prevOffset
    data {
      id
      customer {
        id
        publicId
        organizationName
      }
      collectionId
      status
      fileName
      contentType
      url
      description
      createdAt
      updatedAt
      isTaxDocument
    }
  }
}
    `;
export const useUploadedFilesQuery = <TData = UploadedFilesQuery, TError = unknown>(
  variables: UploadedFilesQueryVariables,
  options?: UseQueryOptions<UploadedFilesQuery, TError, TData>
) =>
  useQuery<UploadedFilesQuery, TError, TData>(
    ["UploadedFiles", variables],
    useRpiGraphqlRequest<UploadedFilesQuery, UploadedFilesQueryVariables>(UploadedFilesDocument).bind(null, variables),
    options
  );
